<template>
    <div class="wizard__wrap" style="max-width: 1200px">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">
                    {{ agencyName }}
                </div>
            </div>

            <div class="wizard__block-dealname">
                {{ currentDealName || "" }}
            </div>
            <div class="wizard__block-service-name" v-if="currentServiceName">
                Service: <b>{{ currentServiceName || "" }}</b>
            </div>
            <div class="wizard_sale_wrap row" v-if="sale_line_item">
                <!-- IF Services Provided - Invoice issued -->
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="
                        !is_no_service_prodided &&
                        !is_billing_delayed &&
                        !is_amount_diff &&
                        !is_collected_section &&
                        !is_not_value_for_collected
                    "
                >
                    <div class="">
                        <!-- Question 1. Did you provide service?-->
                        <div class="form-question-item">
                            <p class="title">
                                Did you provide service(-s) in
                                <span class="red">{{ currentMonth }}</span
                                >?
                            </p>
                            <div class="form-question-item__wrap">
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_provide_service ===
                                            true
                                        "
                                        :id="`is_provide_service_true`"
                                        :key="`is_provide_service_true`"
                                        name="is_provide_service"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeProvideService(true)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_provide_service_true`"
                                        >Yes</label
                                    >
                                </div>
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_provide_service ===
                                            false
                                        "
                                        :id="`is_provide_service_false`"
                                        :key="`is_provide_service_false`"
                                        name="is_provide_service"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeProvideService(false)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_provide_service_false`"
                                        >No</label
                                    >
                                </div>
                            </div>
                            <div
                                class="col-xl-12 col-lg-12 col-md-12 wizard_sale_controls no-r-border"
                                v-if="
                                    questionnnare.is_provide_service === false
                                "
                            >
                                <p class="title">
                                    Please provide reason why no services were
                                    provided in
                                    <span class="red">{{ currentMonth }}</span>
                                </p>
                                <div class="wizard_sale_wrap--reasons">
                                    <div
                                        class="form-field form-field--radiobutton"
                                        v-for="(reason, index) in sale_line_item
                                            .deal_line_item.type_id !== 1
                                            ? reasons_list.slice(0, 5)
                                            : reasons_list"
                                        :key="`${reason.id}__${sale_line_item.period}__${index}`"
                                    >
                                        <input
                                            type="radio"
                                            :checked="
                                                selected_reason === reason.id
                                            "
                                            :id="`reason_${reason.id}`"
                                            name="reason_id"
                                            v-model="selected_reason"
                                            class="type-create-deals js-edit-deal-type"
                                            :value="reason.id"
                                            @change="onChangeReasonType"
                                        />
                                        <label
                                            style="
                                                margin-bottom: 5px;
                                                margin-right: 12px;
                                            "
                                            :for="`reason_${reason.id}`"
                                            >{{ reason.name }}</label
                                        >
                                    </div>
                                    <div
                                        class="wizard_sale_invoiced-controls explanation--3"
                                        :key="
                                            !sale_line_item.is_new_project &&
                                            !sale_line_item.is_new_retainer
                                                ? `${sale_line_item.deal_line_item.id}__${sale_line_item.period}__explanation`
                                                : `${sale_line_item.id}__explanation`
                                        "
                                    >
                                        <div
                                            class="form-field form-field--text"
                                        >
                                            <label style="text-align: left"
                                                >Explanation</label
                                            >
                                            <textarea
                                                v-model="
                                                    sale_line_item.explanation
                                                "
                                                style="
                                                    height: 125px;
                                                    border-radius: 2px;
                                                "
                                                @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Question 2. Did you issue invoice?-->
                        <div
                            class="form-question-item"
                            v-if="questionnnare.is_provide_service"
                        >
                            <p class="title">
                                Did you issue invoice in
                                <span class="red">{{ currentMonth }}</span
                                >?
                            </p>
                            <div class="form-question-item__wrap">
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_issue_invoice ===
                                            true
                                        "
                                        :id="`is_issue_invoice_true`"
                                        :key="`is_issue_invoice_true`"
                                        name="is_issue_invoice"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeIssueService(true)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_issue_invoice_true`"
                                        >Yes</label
                                    >
                                </div>
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_issue_invoice ===
                                            false
                                        "
                                        :id="`is_issue_invoice_false`"
                                        :key="`is_issue_invoice_false`"
                                        name="is_issue_invoice"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeIssueService(false)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_issue_invoice_false`"
                                        >No</label
                                    >
                                </div>
                            </div>
                            <div
                                class="col-xl-12 col-lg-12 col-md-12 wizard_sale_controls no-r-border"
                                v-if="questionnnare.is_issue_invoice === false"
                            >
                                <p class="title">
                                    Please provide reason why billing was
                                    delayed in
                                    <span class="red">{{ currentMonth }}</span>
                                </p>
                                <div class="wizard_sale_wrap--reasons">
                                    <div
                                        class="form-field form-field--radiobutton"
                                        :key="`${reason.id}__${sale_line_item.period}_${index}`"
                                        v-for="(reason, index) in sale_line_item
                                            .deal_line_item.type_id === 2
                                            ? billing_reasons
                                            : billing_reasons.slice(
                                                  1,
                                                  billing_reasons.length
                                              )"
                                    >
                                        <input
                                            type="radio"
                                            :checked="
                                                selected_reason === reason.id
                                            "
                                            :id="`reason_${reason.id}`"
                                            name="reason_id"
                                            v-model="selected_reason"
                                            class="type-create-deals js-edit-deal-type"
                                            :value="reason.id"
                                            @change="onChangeReasonType"
                                        />
                                        <label
                                            style="
                                                margin-bottom: 5px;
                                                margin-right: 12px;
                                            "
                                            :for="`reason_${reason.id}`"
                                            >{{ reason.name }}</label
                                        >
                                    </div>
                                    <div
                                        class="wizard_sale_invoiced-controls explanation--3"
                                        :key="
                                            !sale_line_item.is_new_project &&
                                            !sale_line_item.is_new_retainer
                                                ? `${sale_line_item.deal_line_item.id}__${sale_line_item.period}__explanation`
                                                : `${sale_line_item.id}__explanation`
                                        "
                                    >
                                        <div
                                            class="form-field form-field--text"
                                        >
                                            <label style="text-align: left"
                                                >Explanation</label
                                            >
                                            <textarea
                                                v-model="
                                                    sale_line_item.explanation
                                                "
                                                style="
                                                    height: 125px;
                                                    border-radius: 2px;
                                                "
                                                @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Question 3. Did you receive payment?-->
                        <div
                            class="form-question-item"
                            v-if="
                                questionnnare.is_provide_service &&
                                questionnnare.is_issue_invoice
                            "
                        >
                            <p class="title">Did you receive payment?</p>
                            <div class="form-question-item__wrap">
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_receive_payment ===
                                            true
                                        "
                                        :id="`is_receive_payment_true`"
                                        :key="`is_receive_payment_true`"
                                        name="is_receive_payment"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeReceivePayment(true)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_receive_payment_true`"
                                        >Yes</label
                                    >
                                </div>
                                <div class="form-field form-field--radiobutton">
                                    <input
                                        type="radio"
                                        :checked="
                                            questionnnare.is_receive_payment ===
                                            false
                                        "
                                        :id="`is_receive_payment_false`"
                                        :key="`is_receive_payment_false`"
                                        name="is_receive_payment"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="
                                            () => onChangeReceivePayment(false)
                                        "
                                    />
                                    <label
                                        style="
                                            margin-bottom: 5px;
                                            margin-right: 12px;
                                        "
                                        :for="`is_receive_payment_false`"
                                        >No</label
                                    >
                                </div>
                            </div>
                        </div>

                        <div
                            class="wizard_sale_invoiced-controls"
                            v-if="
                                questionnnare.is_issue_invoice === true &&
                                questionnnare.is_provide_service === true &&
                                questionnnare.is_receive_payment !== null
                            "
                        >
                            <template
                                v-if="
                                    !sale_line_item.is_new_project &&
                                    !sale_line_item.is_new_retainer
                                "
                            >
                                <!-- IF NOT is_retainer and is_new_project -->
                                <div class="form-field form-field--calc">
                                    <label>Invoice number (optional)</label>
                                    <div
                                        v-if="
                                            sale_line_item.status.id === 1 ||
                                            sale_line_item.status.id === 12 ||
                                            sale_line_item.status.id === 14
                                        "
                                    >
                                        <input
                                            v-model="
                                                sale_line_item.invoice_number
                                            "
                                            @input="
                                                (e) =>
                                                    updateInvoiceNumber(
                                                        e.target.value,
                                                        sale_line_item.sale.id,
                                                        'invoice_number',
                                                        sale_line_item.id
                                                    )
                                            "
                                        />
                                    </div>
                                    <div class="value" v-else>
                                        {{ sale_line_item.invoice_number }}
                                    </div>
                                </div>
                                <div class="separator"></div>
                                <div class="form-field form-field--calc">
                                    <label>Amount</label>
                                    <div
                                        v-if="
                                            sale_line_item.status.id === 1 ||
                                            sale_line_item.status.id === 12 ||
                                            sale_line_item.status.id === 14 ||
                                            sale_line_item.status.id === 15 ||
                                            sale_line_item.status.id === 10
                                        "
                                    >
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.amount"
                                            :change="
                                                (value, _key) => {
                                                    updateInputAmount(
                                                        value,
                                                        sale_line_item.id,
                                                        _key
                                                    );
                                                }
                                            "
                                            :key_input="'amount'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                    <div class="value" v-else>
                                        ${{
                                            numberWithCommas(
                                                sale_line_item.amount
                                            )
                                        }}
                                    </div>
                                </div>
                                <div class="form-field form-field--calc">
                                    <label>Outstanding Balance</label>
                                    <div class="value">
                                        ${{ sale_line_item.outstanding_balance }}
                                    </div>
                                </div>

                                <div class="form-field form-field--calc">
                                    <label>Required payment</label>
                                    <div class="value">
                                        ${{ Math.max(parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance), 0) }}
                                    </div>
                                </div>
                                <div
                                    class="form-field form-field--calc"
                                    v-if="questionnnare.is_receive_payment"
                                >
                                    <label>Collected</label>
                                    <div
                                        v-if="
                                            sale_line_item.status.id === 1 ||
                                            sale_line_item.status.id === 5 ||
                                            sale_line_item.status.id === 12 ||
                                            sale_line_item.status.id === 14 ||
                                            sale_line_item.status.id === 15 ||
                                            sale_line_item.status.id === 10
                                        "
                                    >
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.collected"
                                            :change="
                                                (value, _key) => {
                                                    updateInputCollected(
                                                        value,
                                                        sale_line_item.id,
                                                        _key
                                                    );
                                                }
                                            "
                                            :key_input="'collected'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                    <div class="value" v-else>
                                        ${{
                                            numberWithCommas(
                                                sale_line_item.collected
                                            )
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="form-field form-field--calc"
                                    v-if="
                                        sale_line_item.deal_line_item.deal
                                            .commission_type_id !== 1
                                    "
                                >
                                    <label>Hard cost</label>
                                    <div
                                        v-if="
                                            (sale_line_item.deal_line_item.deal
                                                .commission_type_id === 2 &&
                                                sale_line_item.status.id ===
                                                    1) ||
                                            sale_line_item.status.id === 5 ||
                                            sale_line_item.status.id === 12 ||
                                            sale_line_item.status.id === 14
                                        "
                                    >
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.hard_cost"
                                            :disabled="
                                                !sale_line_item.collected ||
                                                sale_line_item.collected <= 0
                                            "
                                            :change="
                                                (value, _key) => {
                                                    updateInputHardCost(
                                                        value,
                                                        sale_line_item.id,
                                                        _key
                                                    );
                                                }
                                            "
                                            :key_input="'hard_cost'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                    <div class="value" v-else>
                                        ${{
                                            numberWithCommas(
                                                sale_line_item.hard_cost
                                            )
                                        }}
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        sale_line_item.deal_line_item.deal
                                            .commission_type_id !== 1 &&
                                        Number(sale_line_item.hard_cost) >
                                            Number(sale_line_item.amount) *
                                                (Number(
                                                    sale_line_item
                                                        .deal_line_item.deal.cap
                                                ) /
                                                    100)
                                    "
                                    class="form-field form-field--text"
                                    style="margin-bottom: 16px"
                                >
                                    <label style="text-align: left"
                                        >Explanation</label
                                    >
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="
                                            height: 125px;
                                            border-radius: 10px;
                                        "
                                        @input="
                                            (e) => {
                                                if (
                                                    !sale_line_item.is_new_project &&
                                                    !sale_line_item.is_new_retainer
                                                ) {
                                                    updateExplanation(
                                                        e.target.value,
                                                        sale_line_item.id,
                                                        'explanation',
                                                        null
                                                    );
                                                } else {
                                                    updateProjectExplanation(
                                                        e.target.value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        'explanation',
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    );
                                                }
                                            }
                                        "
                                    ></textarea>
                                </div>
                            </template>

                            <!-- IF is_retainer and is_new_project -->
                            <template v-else>
                                <div class="form-field form-field--calc">
                                    <label>Invoice number (optional)</label>
                                    <div
                                        v-if="
                                            sale_line_item.status.id === 1 ||
                                            sale_line_item.status.id === 12 ||
                                            sale_line_item.status.id === 14 ||
                                            sale_line_item.status.id === 15 ||
                                            sale_line_item.status.id === 10
                                        "
                                    >
                                        <input
                                            v-model="
                                                sale_line_item.invoice_number
                                            "
                                            @input="
                                                (e) =>
                                                    updateProjectInvoiceNumber(
                                                        e.target.value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        'invoice_number',
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    )
                                            "
                                        />
                                    </div>
                                    <div class="value" v-else>
                                        {{ sale_line_item.invoice_number }}
                                    </div>
                                </div>
                                <div class="separator"></div>
                                <div class="form-field form-field--calc">
                                    <label>Amount</label>
                                    <!-- :value="sale_line_item.amount" -->
                                    <div>
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.amount"
                                            :change="
                                                (value, _key) => {
                                                    updateProjectInputAmount(
                                                        value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        _key,
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    );
                                                }
                                            "
                                            :key_input="'amount'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                </div>
                                <div class="form-field form-field--calc">
                                    <label>Outstanding Balance</label>
                                    <div class="value">
                                        ${{ sale_line_item.outstanding_balance }}
                                    </div>
                                </div>
                                <div class="form-field form-field--calc">
                                    <label>Required payment</label>
                                    <div class="value">
                                        ${{ Math.max(parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance), 0) }}
                                    </div>
                                </div>
                                <div
                                    class="form-field form-field--calc"
                                    v-if="questionnnare.is_receive_payment"
                                >
                                    <label>Collected</label>
                                    <div>
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.collected"
                                            :change="
                                                (value, _key) => {
                                                    updateProjectInputCollected(
                                                        value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        _key,
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    );
                                                }
                                            "
                                            :key_input="'collected'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="form-field form-field--calc"
                                    v-if="
                                        sale_line_item.deal_line_item.deal
                                            .commission_type_id !== 1
                                    "
                                >
                                    <label>Hard cost</label>
                                    <div>
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.hard_cost"
                                            :disabled="
                                                !sale_line_item.collected ||
                                                sale_line_item.collected <= 0
                                            "
                                            :change="
                                                (value, _key) => {
                                                    updateProjectInputHardCost(
                                                        value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        _key,
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    );
                                                }
                                            "
                                            :key_input="'hard_cost'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        sale_line_item.deal_line_item.deal
                                            .commission_type_id !== 1 &&
                                        Number(sale_line_item.hard_cost) >
                                            Number(sale_line_item.amount) *
                                                (Number(
                                                    sale_line_item
                                                        .deal_line_item.deal.cap
                                                ) /
                                                    100)
                                    "
                                    class="form-field form-field--text"
                                    style="margin-bottom: 16px"
                                >
                                    <label style="text-align: left"
                                        >Explanation</label
                                    >
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="
                                            height: 125px;
                                            border-radius: 10px;
                                        "
                                        @input="
                                            (e) => {
                                                if (
                                                    !sale_line_item.is_new_project &&
                                                    !sale_line_item.is_new_retainer
                                                ) {
                                                    updateExplanation(
                                                        e.target.value,
                                                        sale_line_item.id,
                                                        'explanation',
                                                        null
                                                    );
                                                } else {
                                                    updateProjectExplanation(
                                                        e.target.value,
                                                        sale_line_item
                                                            .deal_line_item.id,
                                                        'explanation',
                                                        sale_line_item.is_new_retainer,
                                                        sale_line_item.period
                                                    );
                                                }
                                            }
                                        "
                                    ></textarea>
                                </div>
                            </template>
                            <div
                                class="form-field form-field--calc"
                                v-if="questionnnare.is_receive_payment"
                            >
                                <label>Eligible amount</label>
                                <div class="value">
                                    ${{ sale_line_item.eligible_amount }}
                                </div>
                            </div>
                            <div
                                class="form-field form-field--calc"
                                v-if="questionnnare.is_receive_payment"
                            >
                                <label>Commission, %</label>
                                <div class="value">
                                    {{ sale_line_item.procent }}%
                                </div>
                            </div>
                            <div
                                class="separator"
                                v-if="questionnnare.is_receive_payment"
                            ></div>
                            <div
                                class="form-field form-field--owed"
                                v-if="questionnnare.is_receive_payment"
                            >
                                <label>Commission owed</label>
                                <div class="value">
                                    ${{ sale_line_item.commission_owed }}
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- question Reason why collected amount is less than the invoice amount -->
                        <div
                            class="form-question-item"
                            v-if="((!is_collected_section &&
                                    questionnnare.is_provide_service === true)) &&
                            questionnnare.is_receive_payment === true && (
                                ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) < parseFromString(sale_line_item.amount)
                                && (parseFromString(sale_line_item.amount) - (parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)))
                                > (parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance)) * threshold) && (sale_line_item.collected || sale_line_item.collected == 0)
                                && sale_line_item.amount)
                                "
                        >
                            <p class="title">
                                Please specify the reason why the collected amount is less than the invoice amount 1
                            </p>
                            <div class="wizard_sale_wrap--reasons">
                                <div
                                    class="form-field form-field--radiobutton"
                                    v-for="(reason, index) in collected_less_amount"
                                    :key="`collected_reason_${reason.id}`"
                                >
                                    <input
                                        type="radio"
                                        :id="`reason_${reason.id}`"
                                        :checked="selected_reason === reason.id"
                                        name="reason_id"
                                        v-model="selected_reason"
                                        :value="+reason.id"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="onChangeReasonType"
                                    />
                                    <label
                                        style="margin-bottom: 5px; margin-right: 12px"
                                        :for="`reason_${reason.id}`"
                                    >
                                        {{ reason.name }}
                                    </label>
                                </div>

                                <div
                                    class="form-field form-field--text"
                                >
                                    <label style="text-align: left">Explanation</label>
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="height: 125px; border-radius: 2px"
                                        @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div
                            class="form-question-item"
                            v-else-if="
                            ((!is_collected_section &&
                                questionnnare.is_provide_service === true)) &&
                                questionnnare.is_receive_payment === true &&
                                sale_line_item.collected &&
                                sale_line_item.amount && (
                                ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) > parseFromString(sale_line_item.amount)
                                && ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) - parseFromString(sale_line_item.amount))
                                > (parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance)) * threshold)
                                )
                                "
                        >
                            <p class="title">
                                Please specify the reason why the collected amount is more than the invoice amount
                            </p>
                            <div class="wizard_sale_wrap--reasons">
                                <div
                                    class="form-field form-field--radiobutton"
                                    v-for="(reason, index) in amount_less_collected"
                                    :key="`collected_reason_${reason.id}`"
                                >
                                    <input
                                        type="radio"
                                        :id="`reason_${reason.id}`"
                                        :checked="selected_reason === reason.id"
                                        name="reason_id"
                                        v-model="selected_reason"
                                        :value="+reason.id"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="onChangeReasonType"
                                    />
                                    <label
                                        style="margin-bottom: 5px; margin-right: 12px"
                                        :for="`reason_${reason.id}`"
                                    >
                                        {{ reason.name }}
                                    </label>
                                </div>

                                <div
                                    class="form-field form-field--text"
                                >
                                    <label style="text-align: left">Explanation</label>
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="height: 125px; border-radius: 2px"
                                        @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                    ></textarea>
                                </div>
                            </div>
                        </div>




                </div>
                <!-- IF Billing delayed (Services Provided - No Invoice issued) -->
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="is_billing_delayed"
                >
                    <div class="title">
                        Please provide reason why billing was delayed in
                        <span class="red">{{ currentMonth }}</span>
                    </div>

                    <div class="wizard_sale_wrap--reasons">
                        <div
                            class="form-field form-field--radiobutton"
                            :key="`${reason.id}__${sale_line_item.period}_${index}`"
                            v-for="(reason, index) in sale_line_item
                                .deal_line_item.type_id === 2
                                ? billing_reasons
                                : billing_reasons.slice(
                                      1,
                                      billing_reasons.length
                                  )"
                        >
                            <input
                                type="radio"
                                :checked="selected_reason === reason.id"
                                :id="`reason_${reason.id}`"
                                name="reason_id"
                                v-model="selected_reason"
                                class="type-create-deals js-edit-deal-type"
                                :value="reason.id"
                                @change="onChangeReasonType"
                            />
                            <label
                                style="margin-bottom: 5px; margin-right: 12px"
                                :for="`reason_${reason.id}`"
                                >{{ reason.name }}</label
                            >
                        </div>
                        <div
                            class="wizard_sale_invoiced-controls explanation--3"
                            :key="
                                !sale_line_item.is_new_project &&
                                !sale_line_item.is_new_retainer
                                    ? `${sale_line_item.deal_line_item.id}__${sale_line_item.period}__explanation`
                                    : `${sale_line_item.id}__explanation`
                            "
                        >
                            <div class="form-field form-field--text">
                                <label style="text-align: left"
                                    >Explanation</label
                                >
                                <textarea
                                    v-model="sale_line_item.explanation"
                                    style="height: 125px; border-radius: 2px"
                                    @input="
                                        (e) => {
                                            if (
                                                !sale_line_item.is_new_project &&
                                                !sale_line_item.is_new_retainer
                                            ) {
                                                updateExplanation(
                                                    e.target.value,
                                                    sale_line_item.id,
                                                    'explanation',
                                                    null
                                                );
                                            } else {
                                                updateProjectExplanation(
                                                    e.target.value,
                                                    sale_line_item
                                                        .deal_line_item.id,
                                                    'explanation',
                                                    sale_line_item.is_new_retainer,
                                                    sale_line_item.period
                                                );
                                            }
                                        }
                                    "
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- IF No services provided -->
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="is_no_service_prodided"
                >
                    <div class="title">
                        Please provide reason why no services were provided in
                        <span class="red">{{ currentMonth }}</span>
                    </div>

                    <div class="wizard_sale_wrap--reasons">
                        <div
                            class="form-field form-field--radiobutton"
                            v-for="(reason, index) in reasons_list"
                            :key="`${reason.id}__${sale_line_item.period}__${index}`"
                        >
                            <input
                                type="radio"
                                :checked="selected_reason === reason.id"
                                :id="`reason_${reason.id}`"
                                name="reason_id"
                                v-model="selected_reason"
                                class="type-create-deals js-edit-deal-type"
                                :value="reason.id"
                                @change="onChangeReasonType"
                            />
                            <label
                                style="margin-bottom: 5px; margin-right: 12px"
                                :for="`reason_${reason.id}`"
                                >{{ reason.name }}</label
                            >
                        </div>
                        <div
                            class="wizard_sale_invoiced-controls explanation--3"
                            :key="
                                !sale_line_item.is_new_project &&
                                !sale_line_item.is_new_retainer
                                    ? `${sale_line_item.deal_line_item.id}__${sale_line_item.period}__explanation`
                                    : `${sale_line_item.id}__explanation`
                            "
                        >
                            <div class="form-field form-field--text">
                                <label style="text-align: left"
                                    >Explanation</label
                                >
                                <textarea
                                    v-model="sale_line_item.explanation"
                                    style="height: 125px; border-radius: 2px"
                                    @input="
                                        (e) => {
                                            if (
                                                !sale_line_item.is_new_project &&
                                                !sale_line_item.is_new_retainer
                                            ) {
                                                updateExplanation(
                                                    e.target.value,
                                                    sale_line_item.id,
                                                    'explanation',
                                                    null
                                                );
                                            } else {
                                                updateProjectExplanation(
                                                    e.target.value,
                                                    sale_line_item
                                                        .deal_line_item.id,
                                                    'explanation',
                                                    sale_line_item.is_new_retainer,
                                                    sale_line_item.period
                                                );
                                            }
                                        }
                                    "
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="is_amount_diff"
                >
                    <div class="title">
                        Why does the amount you entered differ from the amount
                        indicated on the SOW?
                    </div>

                    <div class="wizard_sale_wrap--reasons">
                        <div
                            class="form-field form-field--radiobutton"
                            v-for="(reason, index) in amount_reasons"
                            :key="`${reason.id}__${index}`"
                        >
                            <input
                                type="radio"
                                :checked="selected_reason === reason.id"
                                :id="`reason_${reason.id}`"
                                name="reason_id"
                                class="type-create-deals js-edit-deal-type"
                                :value="reason.id"
                                @change="onChangeReasonType"
                            />
                            <label
                                style="margin-bottom: 5px; margin-right: 12px"
                                :for="`reason_${reason.id}`"
                                >{{ reason.name }}</label
                            >
                        </div>
                    </div>
                </div>
                <!-- IF Need collected -->
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="is_collected_section && !is_not_value_for_collected"
                >
                    <div
                        class="title"
                        v-html="
                            sale_line_item.status.id === 6
                                ? 'Please bring us up to speed on these uncollected amounts:'
                                : `Please provide information about the service activity in <span class='red'>
                        ${currentMonth}</span>:`
                        "
                    ></div>
                    <div class="">
                        <div
                            class="form-field form-field--radiobutton"
                            v-for="(t, index) in types_record_collected"
                            :key="`${t.id}__${sale_line_item.period}__${index}`"
                        >
                        <!-- :checked="type_record === t.id" -->
                            <input
                                type="radio"
                                v-model="type_record"
                                :id="`type_${t.id}`"
                                name="type_id"
                                class="type-create-deals js-edit-deal-type"
                                :value="t.id"
                                @change="onSelectSaleLineItemType"
                            />
                            <label
                                style="margin-bottom: 5px; margin-right: 12px"
                                :for="`type_${t.id}`"
                                >{{ t.name }}</label
                            >
                            <div
                                class="wizard_sale_invoiced-controls type--1"
                                v-if="t.id === 10"
                            >
                                <template
                                    v-if="
                                        !sale_line_item.is_new_project &&
                                        !sale_line_item.is_new_retainer
                                    "
                                >
                                    <!-- IF NOT is_retainer and is_new_project -->
                                    <div class="form-field form-field--calc">
                                        <label>Invoice number</label>
                                        <div
                                            v-if="
                                                sale_line_item.status.id === 1
                                            "
                                        >
                                            <input
                                                :disabled="type_record !== 1"
                                                v-model="
                                                    sale_line_item.invoice_number
                                                "
                                                @input="
                                                    (e) =>
                                                        updateInvoiceNumber(
                                                            e.target.value,
                                                            sale_line_item.sale
                                                                .id,
                                                            'invoice_number',
                                                            sale_line_item.id
                                                        )
                                                "
                                            />
                                        </div>
                                        <div class="value" v-else>
                                            {{ sale_line_item.invoice_number }}
                                        </div>
                                    </div>
                                    <div class="separator"></div>
                                    <div class="form-field form-field--calc">
                                        <label>Amount</label>
                                        <div class="value">
                                            ${{
                                                numberWithCommas(
                                                    sale_line_item.amount
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="form-field form-field--calc">
                                        <label>Outstanding Balance</label>
                                        <div class="value">
                                            ${{ sale_line_item.outstanding_balance }}
                                        </div>
                                    </div>

                                    <div class="form-field form-field--calc">
                                        <label>Required payment</label>
                                        <div class="value">
                                            ${{ Math.max(parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance), 0) }}
                                        </div>
                                    </div>
                                    <div class="form-field form-field--calc">
                                        <label>Collected</label>
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.collected"
                                            :disabled="type_record !== 10"
                                            :change="
                                                (value, _key) => {
                                                    updateInputCollected(
                                                        value,
                                                        sale_line_item.id,
                                                        _key
                                                    );
                                                }
                                            "
                                            :key_input="'collected'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                    <div
                                        class="form-field form-field--calc"
                                        v-if="
                                            sale_line_item.deal_line_item.deal
                                                .commission_type_id !== 1
                                        "
                                    >
                                        <label>Hard cost</label>
                                        <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale_line_item.hard_cost"
                                            :disabled="
                                                type_record !== 10 ||
                                                !sale_line_item.collected ||
                                                sale_line_item.collected <= 0
                                            "
                                            :change="
                                                (value, _key) => {
                                                    updateInputHardCost(
                                                        value,
                                                        sale_line_item.id,
                                                        _key
                                                    );
                                                }
                                            "
                                            :key_input="'hard_cost'"
                                            :isLoading="isLoading"
                                        />
                                    </div>
                                    <div
                                        v-if="
                                            sale_line_item.deal_line_item.deal
                                                .commission_type_id !== 1 &&
                                            Number(sale_line_item.hard_cost) >
                                                Number(sale_line_item.amount) *
                                                    Number(
                                                        sale_line_item
                                                            .deal_line_item.deal
                                                            .cap
                                                    )
                                        "
                                        class="form-field form-field--text"
                                        style="margin-bottom: 16px"
                                    >
                                        <label style="text-align: left"
                                            >Explanation</label
                                        >
                                        <textarea
                                            v-model="sale_line_item.explanation"
                                            style="
                                                height: 125px;
                                                border-radius: 10px;
                                            "
                                            @input="
                                                (e) => {
                                                    if (
                                                        !sale_line_item.is_new_project &&
                                                        !sale_line_item.is_new_retainer
                                                    ) {
                                                        updateExplanation(
                                                            e.target.value,
                                                            sale_line_item.id,
                                                            'explanation',
                                                            null
                                                        );
                                                    } else {
                                                        updateProjectExplanation(
                                                            e.target.value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            'explanation',
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        );
                                                    }
                                                }
                                            "
                                        ></textarea>
                                    </div>
                                    <div class="separator"></div>
                                </template>

                                <!-- IF is_retainer and is_new_project -->
                                <template v-else>
                                    <div class="form-field form-field--calc">
                                        <label>Invoice number</label>
                                        <div
                                            v-if="
                                                sale_line_item.status.id === 1
                                            "
                                        >
                                            <input
                                                :disabled="type_record !== 10"
                                                v-model="
                                                    sale_line_item.invoice_number
                                                "
                                                @input="
                                                    (e) =>
                                                        updateProjectInvoiceNumber(
                                                            e.target.value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            'invoice_number',
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        )
                                                "
                                            />
                                        </div>
                                        <div class="value" v-else>
                                            {{ sale_line_item.invoice_number }}
                                        </div>
                                    </div>
                                    <div class="separator"></div>
                                    <div class="form-field form-field--calc">
                                        <label>Amount</label>
                                        <div class="value">
                                            ${{
                                                numberWithCommas(
                                                    sale_line_item.amount
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="form-field form-field--calc">
                                        <label>Outstanding Balance</label>
                                        <div class="value">
                                            ${{ sale_line_item.outstanding_balance }}
                                        </div>
                                    </div>

                                    <div class="form-field form-field--calc">
                                        <label>Required payment</label>
                                        <div class="value">
                                            ${{ Math.max(parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance), 0) }}
                                        </div>
                                    </div>
                                    <div class="form-field form-field--calc">
                                        <label>Collected</label>
                                        <div>
                                            <CurrencyInput
                                                :options="
                                                    currency_input_setting
                                                "
                                                :value="
                                                    sale_line_item.collected
                                                "
                                                :disabled="type_record !== 10"
                                                :change="
                                                    (value, _key) => {
                                                        updateProjectInputCollected(
                                                            value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            _key,
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        );
                                                    }
                                                "
                                                :key_input="'collected'"
                                                :isLoading="isLoading"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="form-field form-field--calc"
                                        v-if="
                                            sale_line_item.deal_line_item.deal
                                                .commission_type_id !== 1
                                        "
                                    >
                                        <label>Hard cost</label>
                                        <div>
                                            <CurrencyInput
                                                :options="
                                                    currency_input_setting
                                                "
                                                :value="
                                                    sale_line_item.hard_cost
                                                "
                                                :disabled="
                                                    type_record !== 10 ||
                                                    !sale_line_item.collected ||
                                                    sale_line_item.collected <=
                                                        0
                                                "
                                                :change="
                                                    (value, _key) => {
                                                        updateProjectInputHardCost(
                                                            value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            _key,
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        );
                                                    }
                                                "
                                                :key_input="'hard_cost'"
                                                :isLoading="isLoading"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            sale_line_item.deal_line_item.deal
                                                .commission_type_id !== 1 &&
                                            Number(sale_line_item.hard_cost) >
                                                Number(sale_line_item.amount) *
                                                    Number(
                                                        sale_line_item
                                                            .deal_line_item.deal
                                                            .cap
                                                    )
                                        "
                                        class="form-field form-field--text"
                                        style="margin-bottom: 16px"
                                    >
                                        <label style="text-align: left"
                                            >Explanation</label
                                        >
                                        <textarea
                                            v-model="sale_line_item.explanation"
                                            style="
                                                height: 125px;
                                                border-radius: 10px;
                                            "
                                            @input="
                                                (e) => {
                                                    if (
                                                        !sale_line_item.is_new_project &&
                                                        !sale_line_item.is_new_retainer
                                                    ) {
                                                        updateExplanation(
                                                            e.target.value,
                                                            sale_line_item.id,
                                                            'explanation',
                                                            null
                                                        );
                                                    } else {
                                                        updateProjectExplanation(
                                                            e.target.value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            'explanation',
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        );
                                                    }
                                                }
                                            "
                                        ></textarea>
                                    </div>
                                    <div
                                        v-if="
                                            sale_line_item.deal_line_item.deal
                                                .commission_type_id !== 1 &&
                                            Number(sale_line_item.hard_cost) >
                                                Number(sale_line_item.amount) *
                                                    Number(
                                                        sale_line_item
                                                            .deal_line_item.deal
                                                            .cap
                                                    )
                                        "
                                        class="form-field form-field--text"
                                        style="margin-bottom: 16px"
                                    >
                                        <label style="text-align: left"
                                            >Explanation</label
                                        >
                                        <textarea
                                            v-model="sale_line_item.explanation"
                                            style="
                                                height: 125px;
                                                border-radius: 10px;
                                            "
                                            @input="
                                                (e) => {
                                                    if (
                                                        !sale_line_item.is_new_project &&
                                                        !sale_line_item.is_new_retainer
                                                    ) {
                                                        updateExplanation(
                                                            e.target.value,
                                                            sale_line_item.id,
                                                            'explanation',
                                                            null
                                                        );
                                                    } else {
                                                        updateProjectExplanation(
                                                            e.target.value,
                                                            sale_line_item
                                                                .deal_line_item
                                                                .id,
                                                            'explanation',
                                                            sale_line_item.is_new_retainer,
                                                            sale_line_item.period
                                                        );
                                                    }
                                                }
                                            "
                                        ></textarea>
                                    </div>
                                    <div class="separator"></div>
                                </template>
                                <div class="form-field form-field--calc">
                                    <label>Eligible amount</label>
                                    <div class="value">
                                        ${{ sale_line_item.eligible_amount }}
                                    </div>
                                </div>
                                <div class="form-field form-field--calc">
                                    <label>Commission, %</label>
                                    <div class="value">
                                        {{ sale_line_item.procent }}%
                                    </div>
                                </div>
                                <div class="separator"></div>
                                <div class="form-field form-field--owed">
                                    <label>Commission owed</label>
                                    <div class="value">
                                        ${{ sale_line_item.commission_owed }}
                                    </div>
                                </div>
                            </div>


                        </div>

                        <!-- question Reason why collected amount is less than the invoice amount -->
                        <div
                            class="form-question-item"
                            v-if="Number(type_record) !== 11
                                && collectedAmountModified
                                && sale_line_item.collected
                                && sale_line_item.amount
                                && ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) < parseFromString(sale_line_item.amount)
                                && (parseFromString(sale_line_item.amount) - (parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)))
                                > (parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance)) * threshold)"
                        >
                            <p class="title">
                                Please specify the reason why the collected amount is less than the invoice amount
                            </p>
                            <div class="wizard_sale_wrap--reasons">
                                <div
                                    class="form-field form-field--radiobutton"
                                    v-for="(reason, index) in collected_less_amount"
                                    :key="`collected_reason_${reason.id}`"
                                >
                                    <input
                                        type="radio"
                                        :id="`reason_${reason.id}`"
                                        :checked="selected_reason === reason.id"
                                        name="reason_id"
                                        v-model="selected_reason"
                                        :value="+reason.id"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="onChangeReasonType"
                                    />
                                    <label
                                        style="margin-bottom: 5px; margin-right: 12px"
                                        :for="`reason_${reason.id}`"
                                    >
                                        {{ reason.name }}
                                    </label>
                                </div>

                                <div
                                    class="form-field form-field--text"
                                >
                                    <label style="text-align: left">Explanation</label>
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="height: 125px; border-radius: 2px"
                                        @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div
                            class="form-question-item"
                            v-else-if="Number(type_record) !== 11
                                && collectedAmountModified
                                && sale_line_item.collected
                                && sale_line_item.amount
                                && ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) > parseFromString(sale_line_item.amount)
                                && ((parseFromString(sale_line_item.collected) + parseFromString(sale_line_item.outstanding_balance)) - parseFromString(sale_line_item.amount))
                                > (parseFromString(sale_line_item.amount) - parseFromString(sale_line_item.outstanding_balance)) * threshold)
                        ">
                            <p class="title">
                                Please specify the reason why the collected amount is more than the invoice amount
                            </p>
                            <div class="wizard_sale_wrap--reasons">
                                <div
                                    class="form-field form-field--radiobutton"
                                    v-for="(reason, index) in amount_less_collected"
                                    :key="`collected_reason_${reason.id}`"
                                >
                                    <input
                                        type="radio"
                                        :id="`reason_${reason.id}`"
                                        :checked="selected_reason === reason.id"
                                        name="reason_id"
                                        v-model="selected_reason"
                                        :value="+reason.id"
                                        class="type-create-deals js-edit-deal-type"
                                        @change="onChangeReasonType"
                                    />
                                    <label
                                        style="margin-bottom: 5px; margin-right: 12px"
                                        :for="`reason_${reason.id}`"
                                    >
                                        {{ reason.name }}
                                    </label>
                                </div>

                                <div
                                    class="form-field form-field--text"
                                >
                                    <label style="text-align: left">Explanation</label>
                                    <textarea
                                        v-model="sale_line_item.explanation"
                                        style="height: 125px; border-radius: 2px"
                                        @input="
                                                    (e) => {
                                                        if (
                                                            !sale_line_item.is_new_project &&
                                                            !sale_line_item.is_new_retainer
                                                        ) {
                                                            updateExplanation(
                                                                e.target.value,
                                                                sale_line_item.id,
                                                                'explanation',
                                                                null
                                                            );
                                                        } else {
                                                            updateProjectExplanation(
                                                                e.target.value,
                                                                sale_line_item
                                                                    .deal_line_item
                                                                    .id,
                                                                'explanation',
                                                                sale_line_item.is_new_retainer,
                                                                sale_line_item.period
                                                            );
                                                        }
                                                    }
                                                "
                                    ></textarea>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>

                <!-- IF Not collected with status Overdue -->
                <div
                    class="col-xl-8 col-lg-8 col-md-8 wizard_sale_controls"
                    v-if="is_collected_section && is_not_value_for_collected"
                >
                    <div class="title">
                        Please explain why no money were collected for the
                        invoice sent in
                        <span class="red">{{ currentMonth }}</span>
                    </div>

                    <div class="wizard_sale_wrap--reasons">
                        <div
                            class="wizard_sale_invoiced-controls explanation--3"
                            :key="
                                !sale_line_item.is_new_project &&
                                !sale_line_item.is_new_retainer
                                    ? `${sale_line_item.deal_line_item.id}__${sale_line_item.period}__explanation_collected`
                                    : `${sale_line_item.id}__explanation_collected`
                            "
                        >
                            <div class="form-field form-field--text">
                                <label style="text-align: left"
                                    >Explanation</label
                                >
                                <textarea
                                    v-model="sale_line_item.explanation"
                                    style="height: 125px; border-radius: 2px"
                                    @input="
                                        (e) => {
                                            if (
                                                !sale_line_item.is_new_project &&
                                                !sale_line_item.is_new_retainer
                                            ) {
                                                updateExplanation(
                                                    e.target.value,
                                                    sale_line_item.id,
                                                    'explanation',
                                                    null
                                                );
                                            } else {
                                                updateProjectExplanation(
                                                    e.target.value,
                                                    sale_line_item
                                                        .deal_line_item.id,
                                                    'explanation',
                                                    sale_line_item.is_new_retainer,
                                                    sale_line_item.period
                                                );
                                            }
                                        }
                                    "
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 wizard_sale_details">
                    <div
                        class="title"
                        :data-sale-id="
                            sale_line_item.hasOwnProperty('id')
                                ? sale_line_item.id
                                : sale_line_item.deal_line_item.id
                        "
                    >
                        Service details
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.service &&
                            sale_line_item.service.label
                        "
                    >
                        <div class="label">Service:</div>
                        <div class="value">
                            {{ sale_line_item.service.label || "-" }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="sale_line_item.deal_line_item.custom_service"
                    >
                        <div class="label">Custom service:</div>
                        <div class="value">
                            {{
                                sale_line_item.deal_line_item.custom_service ||
                                "-"
                            }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="label">Type:</div>
                        <div class="value">
                            {{
                                getTypeName(
                                    sale_line_item.deal_line_item.type_id
                                ) || "-"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="sale_line_item.deal_line_item.kickoff_date"
                    >
                        <div class="label">Kick-off date:</div>
                        <div class="value">
                            {{
                                kickOffDateFormat(
                                    sale_line_item.deal_line_item.kickoff_date
                                )
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 1 &&
                            sale_line_item.deal_line_item.amount &&
                            !sale_line_item.deal_line_item.fluctuating_fee
                        "
                    >
                        <div class="label">Monthly fee:</div>
                        <div class="value">
                            ${{
                                numberWithCommas(
                                    sale_line_item.deal_line_item.amount
                                ) || "-"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 1 &&
                            sale_line_item.deal_line_item.fluctuating_fee
                        "
                    >
                        <div class="label">Fluctuating fee:</div>
                        <div class="value">
                            {{
                                sale_line_item.deal_line_item.fluctuating_fee
                                    ? "Yes"
                                    : "No"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 1 &&
                            sale_line_item.deal_line_item.frequency_retainer
                        "
                    >
                        <div class="label">Frequency:</div>
                        <div class="value">
                            {{
                                Number(
                                    sale_line_item.deal_line_item
                                        .frequency_retainer
                                ) === 1
                                    ? "1m"
                                    : "1y"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 2 &&
                            sale_line_item.deal_line_item.amount
                        "
                    >
                        <div class="label">Full amount:</div>
                        <div class="value">
                            ${{
                                numberWithCommas(
                                    sale_line_item.deal_line_item.amount
                                ) || "-"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 2 &&
                            sale_line_item.deal_line_item.num_of_payments
                        "
                    >
                        <div class="label">Number of pmts:</div>
                        <div class="value">
                            {{ sale_line_item.deal_line_item.num_of_payments || sale_line_item.deal_line_item.current_number_payment ?
                                ((sale_line_item.deal_line_item.current_number_payment || "-") + " " + "(" + sale_line_item.deal_line_item.num_of_payments + ")") :
                            "-" }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 2 &&
                            sale_line_item.deal_line_item.num_of_payments
                        "
                    >
                        <div class="label">Total summary:</div>
                        <div class="value">
                            {{
                                sale_line_item.deal_line_item.num_of_payments ||
                                "-"
                            }}
                        </div>
                    </div>
                    <!-- <div> -->
                        <div
                            class="row"
                            v-if="
                                sale_line_item.full_amount_later
                            "
                        >
                            <div class="label">Reason: </div>
                            <div class="value">
                                Full amount will be paid later
                            </div>
                        </div>
                        <div
                            class="row"
                            v-else-if="
                                sale_line_item.is_dissapproved
                            "
                        >
                            <div class="label">Reason: </div>
                            <div class="value">
                                Is dissapproved
                            </div>
                        </div>
                    <!-- </div> -->
                    <div
                        class="row"
                        v-if="
                            sale_line_item.deal_line_item.type_id === 3 &&
                            sale_line_item.deal_line_item.amount
                        "
                    >
                        <div class="label">One-time fee:</div>
                        <div class="value">
                            ${{
                                numberWithCommas(
                                    sale_line_item.deal_line_item.amount
                                ) || "-"
                            }}
                        </div>
                    </div>
                    <div
                        class="row"
                        v-if="
                            sale_line_item.cumulative_difference || sale_line_item.cumulative_difference === 0
                        "
                    >
                        <div class="label" :style="{ color: sale_line_item.cumulative_difference < 0 ? 'red' : '' }">Outstanding balance:</div>
                        <div :style="{ color: sale_line_item.cumulative_difference < 0 ? 'red' : '' }" class="value" >
                            {{sale_line_item.cumulative_difference > 0 ? '+' : ''}}
                            ${{
                                numberWithCommas(
                                    sale_line_item.cumulative_difference
                                ) || "-"
                            }}
                        </div>
                    </div>

                    <div
                        class="title"
                        style="margin-top: 40px; margin-bottom: 24px"
                    >
                        Sale history
                    </div>

                    <div class="row">
                        <table class="table">
                            <thead>
                                <th>Period</th>
                                <th>Invoiced</th>
                                <th>Collected</th>
                                <th>Commission</th>
                            </thead>
                            <tbody>
                                <template
                                    v-if="
                                        sale_line_item.history &&
                                        sale_line_item.history.length
                                    "
                                >
                                    <tr
                                        v-for="__item in sale_line_item.history"
                                    >
                                        <td>{{ __item.period }}</td>
                                        <td>${{ __item.amount }}</td>
                                        <td>${{ __item.collected }}</td>
                                        <td>${{ __item.commission_owed }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="4">No data</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button
                    type="button"
                    @click="onPrevSection"
                    :disabled="isLoading || !initPage"
                    class="btn btn--prev btn--white"
                >
                    Previous
                </button>
                <button
                    type="button"
                    @click="onSave"
                    :disabled="isLoading || !initPage"
                    class="btn btn--next btn--gray"
                >
                    Next
                </button>
            </div>

            <div class="loader loader--sale-line-item" v-if="isLoading">
                <clip-loader
                    :loading="isLoading"
                    :color="'#ec4657'"
                    :size="'45px'"
                ></clip-loader>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import moment from "moment";

import ClipLoader from "vue-spinner/src/ClipLoader";

import CurrencyInput from "../components/CurrencyInput";
import { SECTIONS } from "../consts";
import { scrollToTop } from "../../../helpers/_scrollToTop";
import { useRefHistory } from "@vueuse/core";

export default {
    name: "Wizard_Edit_Sale_Line_Item",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isLoading: false,
            initPage: false,
            is_no_service_prodided: false,
            is_billing_delayed: false,
            is_amount_diff: false,
            is_collected_section: false,
            is_not_value_for_collected: false,
            collectedAmountModified: false,
            threshold: null,
            brand_types: [
                {
                    id: 1,
                    name: "Retainer",
                },
                {
                    id: 2,
                    name: "Project",
                },
                {
                    id: 3,
                    name: "One-Time Fee",
                },
            ],
            types_record: [
                {
                    id: 1,
                    name: "Services Provided - Invoice issued",
                },
                {
                    id: 2,
                    name: "Services Provided - No Invoice issued",
                },
                {
                    id: 3,
                    name: "No service provided",
                },
            ],

            types_record_collected: [
                {
                    id: 10,
                    name: "Collected",
                },
                {
                    id: 11,
                    name: "Not collected",
                },
            ],
            type_record: null,
            sale_line_item: null,
            selected_reason_amount_reasons: null,
            is_amount_reasons_page: false,
            currency_input_setting: {
                currency: "USD",
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
            },
            reasons_list: [
                {
                    id: 1,
                    name: "Billing delayed",
                },
                {
                    id: 2,
                    name: "Service canceled",
                },
                {
                    id: 3,
                    name: "Deal canceled",
                },
                {
                    id: 4,
                    name: "Retainer ended",
                },
                {
                    id: 5,
                    name: "Client on hold",
                },
                {
                    id: 14,
                    name: "Service Provided, Invoice Issued Before",
                },
                {
                    id: 17,
                    name: "Service on hold",
                },
            ],

            billing_reasons: [
                // {
                //     id: 6,
                //     name: "Did not reach next payment milestone",
                // },
                {
                    id: 7,
                    name: "Agency late on issuing invoice",
                },
                {
                    id: 8,
                    name: "Agency owed services at no additional cost",
                },
                {
                    id: 18,
                    name: "Have not yet reached next project milestone",
                },
                {
                    id: 9,
                    name: "Other",
                },
            ],
            collected_less_amount: [
                {
                    id: 19,
                    name: "Full amount will be paid later",
                },
                {
                    id: 20,
                    name: "Amount reduced by agreement with the brand",
                },
                {
                    id: 21,
                    name: "Client refused to pay full amount",
                },
                {
                    id: 24,
                    name: "Other",
                }
            ],
            amount_less_collected: [
                {
                    id: 22,
                    name: "Extra work performed beyond invoiced scope",
                },
                {
                    id: 23,
                    name: "Advance payment for future periods",
                },
                {
                    id: 25,
                    name: "Other",
                }
            ],
            amount_reasons: [
                {
                    id: 12,
                    name: "New SOW signed",
                },
                {
                    id: 13,
                    name: 'Changed to "Fluctuating fee"',
                },
            ],
            selected_reason: null,

            // 16848 questionnnare style

            questionnnare: {
                is_provide_service: null,
                is_issue_invoice: null,
                is_receive_payment: null,
            },
        };
    },
    components: {
        ClipLoader,
        CurrencyInput,
    },

    created() {
        this.getData();
    },

    watch: {
        selected_reason(newVal) {
            if(this.questionnnare) {
                if ([19, 20, 21, 24, 22, 23, 25].includes(Number(newVal))) {
                    this.questionnnare.is_provide_service = true;
                    this.questionnnare.is_issue_invoice = true;
                    this.questionnnare.is_receive_payment = true;
                }
            }
        },
        sale_line_item(newVal) {
            // if(this.sale_line_item && (this.sale_line_item.cancel_reason_id === null || this.sale_line_item.cancel_reason_id || this.sale_line_item.cancel_reason_id == "")) {
            //     if ((Number(this.sale_line_item.amount_change_reason) === 12 || Number(this.sale_line_item.amount_change_reason) === 13) && this.sale_line_item.cancel_reason_id == null || !this.sale_line_item.cancel_reason_id.length) {
            //         this.selected_reason = Number(this.sale_line_item.amount_change_reason)
            //     }
            // }
            if(this.questionnnare) {
                if ([19, 20, 21, 24, 22, 23, 25].includes(Number(this.sale_line_item.cancel_reason_id))) {
                    this.questionnnare.is_provide_service = true;
                    this.questionnnare.is_issue_invoice = true;
                    this.questionnnare.is_receive_payment = true;
                }
            }
            if (this.sale_line_item.amount === this.sale_line_item.collected) {
                this.selected_reason = null
            }
            // else if (Number(this.sale_line_item.amount_change_reason) !== 12 || Number(this.sale_line_item.amount_change_reason) !== 13){
            //     this.sale_line_item.amount_change_reason = null
            // }
            console.log("salelineitem",this.sale_line_item)
        }
    },
    mounted() {
        scrollToTop();

        // console.log("is_provide_service", this.questionnnare)
        // console.log("DATA", this.$data)


        const allSalesPages = this.$store.getters.getAllSalesPages;

        if (allSalesPages && allSalesPages.length) {
            const sale =
                allSalesPages[this.currentDealIndex].sales[
                    this.currentSaleIndex
                ];
            if (sale) {
                this.sale_line_item = sale;

                if (sale.status.id === 5 || sale.status.id === 6) {
                    this.is_collected_section = true;
                }

                if (sale.hasOwnProperty("cancel_reason_id")) {
                    this.selected_reason = sale.cancel_reason_id
                        ? Number(sale.cancel_reason_id)
                        : null;

                    switch (Number(sale.cancel_reason_id)) {
                        case 10:
                            this.type_record = 10;
                            break;
                        case 11:
                            this.type_record = 11;
                            break;
                        case sale.cancel_reason_id >= 1 &&
                            this.sale_line_item.cancel_reason_id <= 5:
                            this.type_record = 3;
                            this.questionnnare.is_provide_service = false;
                            break;
                        case sale.cancel_reason_id === 14:
                            this.type_record = 3;
                            this.questionnnare.is_provide_service = false;
                            break;
                        case sale.cancel_reason_id === 17:
                            this.type_record = 3;
                            this.questionnnare.is_provide_service = false;
                            break;
                        case sale.cancel_reason_id > 5 &&
                            sale.cancel_reason_id <= 9:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            this.type_record = 2;
                            break;
                        case sale.cancel_reason_id === 15:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case sale.cancel_reason_id === 16:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = false;
                            break;
                        case sale.cancel_reason_id === 18:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            this.type_record = 2;
                            break;
                        // case ((Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13) && sale.cancel_reason_id == null || sale.cancel_reason_id == ""):
                        //     this.selected_reason = sale.amount_change_reason
                        //     break;
                        case (Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case [19, 20, 21, 24, 22, 23, 25].includes(Number(sale.cancel_reason_id)):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case null:
                            if (sale.amount) {
                                this.type_record = 1;
                            }
                            break;
                        default:
                            this.type_record = null;
                    }
                }
            }
        }
    },
    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        currentDealName() {
            return this.$store.getters.getCurrentDealname;
        },
        currentDealIndex() {
            return this.$store.getters.getDealSalesIndex;
        },
        currentSaleIndex() {
            return this.$store.getters.getSaleSalesIndex;
        },
        currentServiceName() {
            if (
                this.sale_line_item &&
                this.sale_line_item.hasOwnProperty("service") &&
                this.sale_line_item.service
            )
                return this.sale_line_item.service.label;
            else if (
                this.sale_line_item &&
                this.sale_line_item.hasOwnProperty("deal_line_item") &&
                this.sale_line_item.deal_line_item
            ) {
                return this.sale_line_item.deal_line_item.custom_service;
            } else {
                return "";
            }
        },
        editDealId() {
            return this.$store.getters.getEditDealId;
        },
        currentMonth() {
            if (
                this.sale_line_item &&
                this.sale_line_item.hasOwnProperty("period")
            ) {
                const __date = moment(
                    this.sale_line_item.period,
                    "MM/YYYY"
                ).format("MMMM'YY");

                return __date;
            }
        },
        isHasKickOffSales() {
            return this.$store.getters.getIsHasKickOff;
        },
        isHasUploadLaterSOWs() {
            return this.$store.getters.getIsHasUploadLaterSOWs;
        },
        isHasDealCanceled() {
            return this.$store.getters.getIsHasCanceledDeal;
        },
        getIndexSLIDealCanceled() {
            return this.$store.getters.getIndexSLIWithDealCanceled;
        },
    },
    methods: {

        async getData(is_update = false, updatedValue = null) {
            try {
                const res = await axios.post("/api/wizard/getList", {
                    page: "sales",
                });

                const sales_by_deals = [];

                if (!res.data.page || res.data.page.length <= 0) {
                    this.onChangeSection(SECTIONS.INVOICES);
                    return;
                }

                if (res.data.page.length) {
                    res.data.page.forEach((item) => {
                        let deal_name = item.deal.name;
                        let sales = Object.values(item.sales).flat();

                        this.threshold = Number(item.threshold) / 100

                        sales_by_deals.push({
                            deal_id: item.deal.id,
                            deal_name,
                            has_dli: item.deal.hasOwnProperty("has_dli")
                                ? item.deal.has_dli
                                : false,
                            sales: sales,
                            threshold: item.threshold,
                        });
                    });

                    this.checkDealCanceledSLI(sales_by_deals);
                }

                if (sales_by_deals.length) {
                    if (is_update) {
                        const updateData = {
                            deal_index: this.currentDealIndex,
                            sale_index: this.currentSaleIndex,
                            data: {
                                eligible_amount:
                                    sales_by_deals[this.currentDealIndex].sales[
                                        this.currentSaleIndex
                                    ].eligible_amount,
                                procent:
                                    sales_by_deals[this.currentDealIndex].sales[
                                        this.currentSaleIndex
                                    ].procent,
                                commission_owed:
                                    sales_by_deals[this.currentDealIndex].sales[
                                        this.currentSaleIndex
                                    ].commission_owed,
                                cancel_reason_id:
                                    sales_by_deals[this.currentDealIndex].sales[
                                        this.currentSaleIndex
                                    ].cancel_reason_id || null,
                                // full_amount_later:
                                //     sales_by_deals[this.currentDealIndex].sales[
                                //         this.currentSaleIndex
                                //     ].full_amount_later,
                            },
                        };

                        if (updatedValue) {
                            updateData.data[updatedValue.key] =
                                updatedValue.value;
                        }

                        this.$store.commit("updateSaleInList", updateData);
                        return;
                    }

                    this.$store.commit("setSalesPages", sales_by_deals);
                    this.deal_name = sales_by_deals;

                    const currentSaleSelected =
                        sales_by_deals[this.currentDealIndex].sales[
                            this.currentSaleIndex
                        ];

                    if (currentSaleSelected) {
                        this.sale_line_item = currentSaleSelected;
                        this.selected_reason =
                            currentSaleSelected.cancel_reason_id
                                ? Number(currentSaleSelected.cancel_reason_id)
                                : null;
                        this.type_record = null;
                        if (
                            currentSaleSelected.status.id === 5 ||
                            currentSaleSelected.status.id === 6
                        ) {
                            this.is_collected_section = true;

                            switch (
                                Number(currentSaleSelected.cancel_reason_id)
                            ) {
                                case 10:
                                    this.type_record = 10;
                                    break;
                                case 11:
                                    this.type_record = 11;
                                    break;
                            }

                            return;
                        }

                        switch (true) {
                            case Number(currentSaleSelected.cancel_reason_id) >
                                5 &&
                                Number(currentSaleSelected.cancel_reason_id) <=
                                    9:
                                this.type_record = 2;
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = false;
                                break;
                            case Number(currentSaleSelected.cancel_reason_id) ==
                                12 ||
                                Number(currentSaleSelected.cancel_reason_id) ==
                                    13:
                                this.type_record = 1;
                                break;
                            case Number(currentSaleSelected.cancel_reason_id) ==
                                14:
                                this.type_record = 3;
                                this.questionnnare.is_provide_service = false;
                                break;
                            case Number(currentSaleSelected.cancel_reason_id) ==
                                17:
                                this.type_record = 3;
                                this.questionnnare.is_provide_service = false;
                            case Number(currentSaleSelected.cancel_reason_id) ==
                                18:
                                this.type_record = 2;
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = false;
                                break;
                            case Number(currentSaleSelected.cancel_reason_id) >=
                                1 &&
                                Number(currentSaleSelected.cancel_reason_id) <=
                                    5:
                                this.type_record = 3;
                                this.questionnnare.is_provide_service = false;
                                break;
                            case Number(
                                currentSaleSelected.cancel_reason_id
                            ) === 15:
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                                break;
                            case Number(
                                currentSaleSelected.cancel_reason_id
                            ) === 16:
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = false;
                                break;
                            case ((Number(currentSaleSelected.amount_change_reason) === 12 || Number(currentSaleSelected.amount_change_reason) === 13) && currentSaleSelected.cancel_reason_id == null):
                                this.selected_reason = currentSaleSelected.amount_change_reason
                                break;
                            case (Number(currentSaleSelected.amount_change_reason) === 12 || Number(currentSaleSelected.amount_change_reason) === 13):
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                                break;
                            case [19, 20, 21, 24, 22, 23, 25].includes(Number(currentSaleSelected.cancel_reason_id)):
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                                break;
                            case !Number(currentSaleSelected.cancel_reason_id):
                                if (currentSaleSelected.amount) {
                                    this.type_record = 1;
                                } else {
                                    this.type_record = null;
                                }
                                break;
                            default:
                                this.type_record = null;
                        }
                    }
                }

                this.$store.commit(
                    "setCurrentBrandName",
                    res.data.page[this.currentDealIndex].brand.name
                );
            } catch (error) {
                console.error(error);
            } finally {
                setTimeout(() => (this.initPage = true), 1500);


                if (this.collected_less_amount.some(reason => Number(reason.id) === Number(this.selected_reason)) || (this.amount_less_collected.some(reason => Number(reason.id) === Number(this.selected_reason)))) {
                    this.type_record = 10;
                }


                // console.log("selected_reason", this.selected_reason)
                // console.log("type_record",this.type_record)
            }

        },

        getTypeName(id) {
            if (id) {
                const type = this.brand_types.find((i) => i.id === id);

                if (type) {
                    return type.name;
                }
            }

            return "";
        },

        numberWithCommas(x) {
            if (!x) {
                return "0";
            }

            let fixednumber = Number(x).toFixed(2);
            let parts = fixednumber.split(".");

            let integerPart = parts[0]
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            let formattedNumber = integerPart + "." + parts[1];

            return formattedNumber;
        },

        parseFromString(value) {
            return value ? parseFloat(value.toString().replace(',', '')) : 0;
        },
        onPrevSection() {
            if (this.is_amount_diff) {
                scrollToTop();
                this.is_amount_diff = false;
                return;
            }

            if (this.is_no_service_prodided) {
                scrollToTop();
                this.is_no_service_prodided = false;
                return;
            }

            if (this.is_billing_delayed) {
                scrollToTop();
                this.is_billing_delayed = false;
                return;
            }

            if (this.is_not_value_for_collected) {
                scrollToTop();
                this.is_not_value_for_collected = false;
                this.is_collected_section = true;
                return;
            }

            if (this.editDealId) {
                this.onChangeSection(SECTIONS.FINAL_DASHBOARD);
                return;
            }

            if (this.currentDealIndex === 0 && this.currentSaleIndex === 0) {
                if (!this.isHasKickOffSales && !this.isHasUploadLaterSOWs) {
                    this.onChangeSection(SECTIONS.DASHBOARD);
                } else if (this.isHasKickOffSales) {
                    this.onChangeSection(SECTIONS.EDIT_KICK_OFF_LINE_ITEM);
                } else if (this.isHasUploadLaterSOWs) {
                    this.onChangeSection(SECTIONS.UPLOAD_LATER_SOW);
                }
                return;
            }

            const allSalesPages = this.$store.getters.getAllSalesPages;
            const currentDeal = allSalesPages[this.currentDealIndex];

            this.is_collected_section = false;

            if (allSalesPages.length) {
                if (this.currentSaleIndex === 0) {
                    this.$store.commit("decrementDealIndex");
                    this.$store.commit(
                        "setSalesPagesIndex",
                        this.$store.getters.getSalesPagesIndex - 1
                    );
                    const sale = allSalesPages[this.currentDealIndex].sales[0];
                    this.sale_line_item = sale;
                    this.selected_reason = sale.cancel_reason_id
                        ? Number(sale.cancel_reason_id)
                        : null;
                    this.type_record = null;
                    if (sale.status.id === 5 || sale.status.id === 6) {
                        scrollToTop();
                        this.is_collected_section = true;

                        switch (Number(sale.cancel_reason_id)) {
                            case 10:
                                this.type_record = 10;
                                break;
                            case 11:
                                this.type_record = 11;
                                break;
                        }

                        return;
                    }
                    scrollToTop();
                    switch (true) {
                        case Number(sale.cancel_reason_id) > 5 &&
                            Number(sale.cancel_reason_id) <= 9:
                            this.type_record = 2;
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            break;
                        case Number(sale.cancel_reason_id) == 12 ||
                            Number(sale.cancel_reason_id) == 13:
                            this.type_record = 1;
                            break;
                        case (Number(sale.cancel_reason_id) >= 1 &&
                            Number(sale.cancel_reason_id) <= 5) ||
                            Number(sale.cancel_reason_id) == 14 ||
                            Number(sale.cancel_reason_id) == 17:
                            this.type_record = 3;
                            this.questionnnare.is_provide_service = false;
                            break;
                        case Number(sale.cancel_reason_id) === 15:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case Number(sale.cancel_reason_id) === 16:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = false;
                            break;
                        case Number(sale.cancel_reason_id) === 18:
                            this.type_record = 2;
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            break;
                        // case ((Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13) && sale.cancel_reason_id == null || sale.cancel_reason_id == ""):
                        //     this.selected_reason = sale.amount_change_reason
                        //     break;
                        case (Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case [19, 20, 21, 24, 22, 23, 25].includes(Number(sale.cancel_reason_id)):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case !sale.cancel_reason_id:
                            if (sale.amount) {
                                this.type_record = 1;
                            }
                            break;
                        default:
                            this.type_record = null;
                    }
                } else if (this.currentSaleIndex > 0) {
                    let sale =
                        allSalesPages[this.currentDealIndex].sales[
                            this.currentSaleIndex - 1
                        ];
                    if (this.isHasDealCanceled && sale.status.id === 1) {
                        if (
                            this.getIndexSLIDealCanceled <
                            this.currentSaleIndex - 1
                        ) {
                            const __splitArray = currentDeal.sales.slice(
                                0,
                                this.currentSaleIndex - 1
                            );

                            const __sli = __splitArray.find(
                                (sale) => sale.status.id !== 1
                            );

                            if (__sli) {
                                sale = __sli;

                                const __index = currentDeal.sales.findIndex(
                                    (sli) => sli.id === __sli.id
                                );

                                this.$store.commit("setSaleIndex", __index);
                            } else {
                                this.$store.commit(
                                    "setSaleIndex",
                                    this.getIndexSLIDealCanceled
                                );
                                sale =
                                    allSalesPages[this.currentDealIndex].sales[
                                        this.getIndexSLIDealCanceled
                                    ];
                            }

                            this.sale_line_item = sale;
                            this.selected_reason = sale.cancel_reason_id
                                ? Number(sale.cancel_reason_id)
                                : null;
                            scrollToTop();
                            switch (true) {
                                case sale.status.id === 5 ||
                                    sale.status.id === 6:
                                    this.is_collected_section = true;
                                    switch (Number(sale.cancel_reason_id)) {
                                        case 10:
                                            this.type_record = 10;
                                            break;
                                        case 11:
                                            this.type_record = 11;
                                            break;
                                    }
                                    break;
                                case Number(sale.cancel_reason_id) > 5 &&
                                    Number(sale.cancel_reason_id) <= 9:
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = false;
                                    this.type_record = 2;
                                    break;
                                case Number(sale.cancel_reason_id) == 12 ||
                                    Number(sale.cancel_reason_id) == 13:
                                    this.type_record = 1;
                                    break;
                                case (Number(sale.cancel_reason_id) >= 1 &&
                                    Number(sale.cancel_reason_id) <= 5) ||
                                    Number(sale.cancel_reason_id) == 14 ||
                                    Number(sale.cancel_reason_id) == 17:
                                    this.type_record = 3;
                                    this.questionnnare.is_provide_service = false;
                                    break;
                                case Number(sale.cancel_reason_id) === 15:
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = true;
                                    this.questionnnare.is_receive_payment = true;
                                    break;
                                case Number(sale.cancel_reason_id) === 16:
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = true;
                                    this.questionnnare.is_receive_payment = false;
                                    break;
                                case Number(sale.cancel_reason_id) === 18:
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = false;
                                    this.type_record = 2;
                                    break;
                                // case ((Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13) && sale.cancel_reason_id == null || sale.cancel_reason_id == ""):
                                //     this.selected_reason = sale.amount_change_reason
                                //     break;
                                case (Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13):
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = true;
                                    this.questionnnare.is_receive_payment = true;
                                    break;
                                case [19, 20, 21, 24, 22, 23, 25].includes(Number(sale.cancel_reason_id)):
                                    this.questionnnare.is_provide_service = true;
                                    this.questionnnare.is_issue_invoice = true;
                                    this.questionnnare.is_receive_payment = true;
                                    break;
                                case !sale.cancel_reason_id:
                                    if (sale.amount && sale.collected) {
                                        this.type_record = 1;
                                    } else {
                                        this.type_record = null;
                                    }
                                    break;
                                default:
                                    this.type_record = null;
                            }
                            return;
                        }
                    }

                    this.sale_line_item = sale;
                    this.selected_reason = sale.cancel_reason_id
                        ? Number(sale.cancel_reason_id)
                        : null;
                    if (sale.status.id === 5 || sale.status.id === 6) {
                        scrollToTop();
                        this.is_collected_section = true;

                        switch (Number(sale.cancel_reason_id)) {
                            case 10:
                                this.type_record = 10;
                                break;
                            case 11:
                                this.type_record = 11;
                                break;
                        }

                        this.$store.commit("decrementSaleIndex");

                        return;
                    }
                    scrollToTop();
                    switch (true) {
                        case Number(sale.cancel_reason_id) > 5 &&
                            Number(sale.cancel_reason_id) <= 9:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            this.type_record = 2;
                            break;
                        case Number(sale.cancel_reason_id) == 12 ||
                            Number(sale.cancel_reason_id) == 13:
                            this.type_record = 1;
                            break;
                        case (Number(sale.cancel_reason_id) >= 1 &&
                            Number(sale.cancel_reason_id) <= 5) ||
                            Number(sale.cancel_reason_id) == 14 ||
                            Number(sale.cancel_reason_id) == 17:
                            this.type_record = 3;
                            this.questionnnare.is_provide_service = false;
                            break;
                        case Number(sale.cancel_reason_id) === 15:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case Number(sale.cancel_reason_id) === 16:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = false;
                            break;
                        case Number(sale.cancel_reason_id) === 18:
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = false;
                            this.type_record = 2;
                            break;
                        // case ((Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13) && sale.cancel_reason_id == null || sale.cancel_reason_id == ""):
                        //     this.selected_reason = sale.amount_change_reason
                        //     break;
                        case (Number(sale.amount_change_reason) === 12 || Number(sale.amount_change_reason) === 13):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case [19, 20, 21, 24, 22, 23, 25].includes(Number(sale.cancel_reason_id)):
                            this.questionnnare.is_provide_service = true;
                            this.questionnnare.is_issue_invoice = true;
                            this.questionnnare.is_receive_payment = true;
                            break;
                        case !sale.cancel_reason_id:
                            if (sale.amount) {
                                this.type_record = 1;
                            } else {
                                this.type_record = null;
                            }
                            break;
                        default:
                            this.type_record = null;
                    }

                    this.$store.commit("decrementSaleIndex");
                }
            }
        },
        // Send cancel_reason_id
        async onSubmitCancelReason() {
            if (!this.selected_reason) {
                this.$toast.error(
                    'You should choose a "reason" item and fill in the explanation.'
                );
                return;
            }

            try {
                let keyName =  this.selected_reason_amount_reasons == 12 || this.selected_reason_amount_reasons == 13 ? "amount_change_reason" : "cancel_reason_id";
                const update_data = {
                    key: keyName,
                    value: keyName === "cancel_reason_id" ? this.selected_reason : this.selected_reason_amount_reasons,
                };

                if (this.selected_reason === 3 || this.selected_reason === 2) {
                    this.$store.commit("updateSaleCancelReasonId", {
                        deal_index: this.currentDealIndex,
                        sale_index: this.currentSaleIndex,
                        data: update_data,
                    });
                } else {
                    this.$store.commit("updateSaleCancelReasonId", {
                        deal_index: this.currentDealIndex,
                        sale_index: this.currentSaleIndex,
                        data: update_data,
                    });
                    this.resetDealCanceledData();

                    const allSalesPages = this.$store.getters.getAllSalesPages;

                    this.checkDealCanceledSLI(allSalesPages);
                }

                if (
                    this.sale_line_item.is_new_project ||
                    this.sale_line_item.is_new_retainer
                ) {
                    let keyName = this.selected_reason_amount_reasons == 12 || this.selected_reason_amount_reasons == 13 ? "amount_change_reason" : "cancel_reason_id";
                    this.updateProjectInputFunction(
                        keyName === "cancel_reason_id" ? this.selected_reason : this.selected_reason_amount_reasons,
                        this.sale_line_item.deal_line_item.id,
                        keyName,
                        this.sale_line_item.is_new_retainer,
                        this.sale_line_item.period
                    );

                    await this.getData(true);
                    //this.$toast.success("Successfully updated draft");
                    this.selected_reason_amount_reasons = null
                    this.is_no_service_prodided = false;
                    this.is_billing_delayed = false;
                    this.is_amount_diff = false;
                    this.selected_reason = null;
                    this.is_collected_section = false;
                    this.is_not_value_for_collected = false;
                    this.type_record = null;
                    this.resetFormState();
                    this.onNextSale("onSubmitCancelReason 1");
                } else {
                    this.isLoading = true;
                    const res = await axios.post("api/wizard/updateDraft", {
                        action: "updateSaleLineItem",
                        data: {
                            key: keyName,
                            value: keyName === "cancel_reason_id" ? this.selected_reason : this.selected_reason_amount_reasons,
                            id: this.sale_line_item.id,
                        },
                    });

                    //this.$toast.success("Successfully updated draft");
                    await this.getData(true);
                    this.selected_reason_amount_reasons = null
                    this.is_no_service_prodided = false;
                    this.is_billing_delayed = false;
                    this.is_amount_diff = false;
                    this.selected_reason = null;
                    this.is_collected_section = false;
                    this.is_not_value_for_collected = false;
                    this.type_record = null;
                    this.resetFormState();
                    this.onNextSale("onSubmitCancelReason 2");
                }
            } catch (err) {
                console.error("Error onSubmitCancelReason:", err);
                this.$toast.error(
                    "Failed to update sale item. Please try again later."
                );
                this.sendLogToServer(
                    {
                        sale: this.sale_line_item.id,
                        deal_line_item_id:
                            this.sale_line_item.deal_line_item.id,
                        cancel_reason_id: this.selected_reason,
                        is_new_retainer: this.sale_line_item.is_new_retainer,
                        period: this.sale_line_item.period,
                        error: err.message,
                        error_stack: err.stack,
                    },
                    "error"
                );
            } finally {
                this.isLoading = false;
            }
        },

        resetFormState() {
            this.$nextTick(() => {
                scrollToTop(); // Прокрутка вверх
            });
            this.is_no_service_prodided = false;
            this.is_collected_section = false;
            this.is_not_value_for_collected = false;
            this.is_billing_delayed = false;
            this.is_amount_diff = false;
            this.questionnnare.is_provide_service = null;
            this.questionnnare.is_issue_invoice = null;
            this.questionnnare.is_receive_payment = null;
        },

        async onSave() {
            // Questionnaire start



            let q__reason = Number(this.selected_reason);

            // console.log("questionnnare", this.questionnnare)

            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === null
            ) {
                this.$toast.error("You should select an answer");
                return;
            }

            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                (this.questionnnare.is_provide_service === false ||
                    this.questionnnare.is_issue_invoice === false) &&
                !this.sale_line_item.explanation
            ) {
                this.$toast.error("You should fill in the explanation field");
                return;
            }

            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === false
            ) {
                //this.is_no_service_prodided = true;
                if (!this.reasons_list.some((reas) => reas.id === q__reason)) {
                    this.$toast.error("You should select an answer");
                    return;
                }
                await this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            if (
                !this.is_amount_diff &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === false
            ) {
                if (
                    !this.billing_reasons.some((reas) => reas.id === q__reason)
                ) {
                    this.$toast.error("You should select an answer");
                    return;
                }
                await this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === null
            ) {
                this.$toast.error("You should select an answer");
                return;
            }

            if (
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === true &&
                this.questionnnare.is_receive_payment === null
            ) {
                this.$toast.error("You should select an answer");
                return;
            }




           if (this.selected_reason !== 12 && this.selected_reason !== 13) {
                if(
                    !this.is_collected_section &&
                    this.questionnnare.is_provide_service === true &&
                    this.questionnnare.is_receive_payment === true &&
                    (this.sale_line_item.collected || this.sale_line_item.collected === 0)
                ) {
                    if (
                        !this.is_collected_section &&
                        this.questionnnare.is_provide_service === true &&
                        this.questionnnare.is_receive_payment === true &&
                        !this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
                        ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) < this.parseFromString(this.sale_line_item.amount) &&
                        (this.parseFromString(this.sale_line_item.amount) - (this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold)

                        // this.sale_line_item.collected
                    ) {
                        this.$toast.error("You should select an answer");
                        return;
                    } else if (
                        !this.is_collected_section &&
                        this.questionnnare.is_provide_service === true &&
                        this.questionnnare.is_receive_payment === true &&
                        this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
                        ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) < this.parseFromString(this.sale_line_item.amount) &&
                        (this.parseFromString(this.sale_line_item.amount) - (this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold) &&
                        (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)

                    ) {
                        this.$toast.error(
                            "You should fill in the explanation field"
                        );
                        return;
                    }
                }

                // console.log(this.selected_reason !== 12 && )
                if (
                    !this.is_collected_section &&
                    this.questionnnare.is_provide_service === true &&
                    this.questionnnare.is_receive_payment === true &&
                    !this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
                    ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) > this.parseFromString(this.sale_line_item.amount) &&
                    ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) - this.parseFromString(this.sale_line_item.amount))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold)
                    // this.sale_line_item.collected
                ) {
                    this.$toast.error("You should select an answer");
                    return;
                } else if (
                    !this.is_collected_section &&
                    this.questionnnare.is_provide_service === true &&
                    this.questionnnare.is_receive_payment === true &&
                    this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
                    ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) > this.parseFromString(this.sale_line_item.amount) &&
                    ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) - this.parseFromString(this.sale_line_item.amount))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold) &&
                    (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)
                ) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                }
            }




            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === true &&
                this.questionnnare.is_receive_payment === true &&
                this.sale_line_item.amount &&
                this.sale_line_item.collected &&
                this.parseFromString(this.sale_line_item.amount) !==
                this.parseFromString(this.sale_line_item.deal_line_item.amount) &&
                this.sale_line_item.status.id === 1 &&
                this.sale_line_item.deal_line_item.type_id === 1 &&
                !this.sale_line_item.deal_line_item.fluctuating_fee
            ) {
                // if (this.sale_line_item.cancel_reason_id == 2 || this.sale_line_item.cancel_reason_id == 13) {
                //     await this.onSubmitCancelReason();
                //     return;
                // }

                let keyName = this.selected_reason_amount_reasons == 12 || this.selected_reason_amount_reasons == 13 ? "amount_change_reason" : "cancel_reason_id";
                this.updateProjectInputFunction(
                        keyName === "cancel_reason_id" ? this.selected_reason : this.selected_reason_amount_reasons,
                        this.sale_line_item.deal_line_item.id,
                        keyName,
                        this.sale_line_item.is_new_retainer,
                        this.sale_line_item.period
                    );
                this.is_amount_reasons_page = true
                this.is_amount_diff = true;

                return;
            }

            if (this.is_amount_reasons_page) {
                if (this.selected_reason_amount_reasons === null) {
                    this.$toast.error("You should select an answer");
                    return;
                }

                this.is_amount_reasons_page = false

            }


            if (
                !this.is_amount_diff &&
                !this.is_collected_section &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === true &&
                this.questionnnare.is_receive_payment === true &&
                this.sale_line_item.amount &&
                this.sale_line_item.collected &&
                this.parseFromString(this.sale_line_item.amount) !==
                    this.parseFromString(this.sale_line_item.deal_line_item.amount) &&
                this.sale_line_item.status.id === 1 &&
                this.sale_line_item.deal_line_item.type_id === 1 &&
                !this.sale_line_item.deal_line_item.fluctuating_fee
            ) {

                //resetFormState();




                if (
                    this.sale_line_item.deal_line_item.deal
                        .commission_type_id !== 1 &&
                    this.parseFromString(this.sale_line_item.hard_cost) >
                        this.parseFromString(this.sale_line_item.amount) *
                            (Number(
                                this.sale_line_item.deal_line_item.deal.cap
                            ) /
                                100) &&
                    !this.sale_line_item.explanation
                ) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                }

            //     if(
            //         !this.is_collected_section &&
            //         this.questionnnare.is_provide_service === true &&
            //         this.questionnnare.is_receive_payment === true &&
            //         (this.sale_line_item.collected || this.sale_line_item.collected === 0)
            //     ) {
            //         if (
            //             !this.is_collected_section &&
            //             this.questionnnare.is_provide_service === true &&
            //             this.questionnnare.is_receive_payment === true &&
            //             !this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //             Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount)
            //             // this.sale_line_item.collected
            //         ) {
            //             this.$toast.error("You should select an answer111");
            //             return;
            //         } else if (
            //             !this.is_collected_section &&
            //             this.questionnnare.is_provide_service === true &&
            //             this.questionnnare.is_receive_payment === true &&
            //             this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //             Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount) &&
            //             (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)

            //         ) {
            //             this.$toast.error(
            //                 "You should fill in the explanation field"
            //             );
            //             return;
            //         }
            //     }

            //     if (
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     !this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount)
            //     // this.sale_line_item.collected
            // ) {
            //     this.$toast.error("You should select an answer");
            //     return;
            // } else if (
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount) &&
            //     (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)
            // ) {
            //     this.$toast.error(
            //         "You should fill in the explanation field"
            //     );
            //     return;
            // }

                this.is_amount_diff = true;
                    return;
                }

            // console.log("is_amount_diff", this.is_amount_diff)
            // console.log("is_collected_section", this.is_collected_section)
            if (
                this.selected_reason !== 11 &&
                this.is_collected_section &&
                this.questionnnare.is_provide_service === null &&
                !this.collected_less_amount.some(reason => reason.id === this.selected_reason)  &&
                ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) < this.parseFromString(this.sale_line_item.amount)
                         && (this.parseFromString(this.sale_line_item.amount) - (this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold) &&
                this.sale_line_item.collected
            ) {
                this.$toast.error("You should select an answer");
                return;
            }

            if (
                this.selected_reason !== 11 &&
                this.is_collected_section &&
                this.questionnnare.is_provide_service === null &&
                !this.amount_less_collected.some(reason => reason.id === this.selected_reason)  &&
                ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) > this.parseFromString(this.sale_line_item.amount) &&
                ((this.parseFromString(this.sale_line_item.collected) + this.parseFromString(this.sale_line_item.outstanding_balance)) - Number(this.sale_line_item.amount))
                                > (this.parseFromString(this.sale_line_item.amount) - this.parseFromString(this.sale_line_item.outstanding_balance)) * this.threshold) &&
                this.sale_line_item.collected
            ) {
                this.$toast.error("You should select an answer");
                return;
            }

            // if (
            //     this.shouldHideAmount == false &&
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     !this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount)
            //     // this.sale_line_item.collected
            // ) {
            //     this.$toast.error("You should fill in the amounts");

            //     return;
            // }

            // if (
            //     this.shouldHideAmount == false &&
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     !this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount)
            //     // this.sale_line_item.collected
            // ) {
            //     this.$toast.error("You should fill in the amounts");

            //     return;
            // }

            // if (
            //     this.shouldHideAmount == false &&
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === false &&
            //     !this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount)
            // ) {
            //     this.$toast.error("You should fill in the amounts");

            //     return;
            // }


            // if (
            //     this.shouldHideAmount == false &&
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === false &&
            //     !this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount)
            // ) {
            //     this.$toast.error("You should fill in the amounts");

            //     return;
            // }

            // console.log("!this.is_collected_section", !this.is_collected_section)
            // console.log("this.questionnnare.is_provide_service === true", this.questionnnare.is_provide_service === true)
            // console.log("this.questionnnare.is_receive_payment === true", this.questionnnare.is_receive_payment === true)
            // console.log("!this.collected_less_amount.some(reason => reason.id === this.selected_reason)", !this.collected_less_amount.some(reason => reason.id === this.selected_reason))
            // console.log("Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount)", Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount))
            // console.log("this.sale_line_item.collected", this.sale_line_item.collected)
            // console.log("this.sale_line_item.collected == 0", this.sale_line_item.collected == 0)

            // if(
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     (this.sale_line_item.collected || this.sale_line_item.collected === 0)
            // ) {
            //     if (
            //         !this.is_collected_section &&
            //         this.questionnnare.is_provide_service === true &&
            //         this.questionnnare.is_receive_payment === true &&
            //         !this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //         Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount)
            //         // this.sale_line_item.collected
            //     ) {
            //         this.$toast.error("You should select an answer");
            //         return;
            //     } else if (
            //         !this.is_collected_section &&
            //         this.questionnnare.is_provide_service === true &&
            //         this.questionnnare.is_receive_payment === true &&
            //         this.collected_less_amount.some(reason => reason.id === this.selected_reason) &&
            //         Number(this.sale_line_item.collected) < Number(this.sale_line_item.amount) &&
            //         (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)

            //     ) {
            //         this.$toast.error(
            //             "You should fill in the explanation field"
            //         );
            //         return;
            //     }
            // }

            // if (
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     !this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount)
            //     // this.sale_line_item.collected
            // ) {
            //     this.$toast.error("You should select an answer5555");
            //     return;
            // } else if (
            //     !this.is_collected_section &&
            //     this.questionnnare.is_provide_service === true &&
            //     this.questionnnare.is_receive_payment === true &&
            //     this.amount_less_collected.some(reason => reason.id === this.selected_reason) &&
            //     Number(this.sale_line_item.collected) > Number(this.sale_line_item.amount) &&
            //     (!this.sale_line_item.explanation || this.sale_line_item.explanation.trim().length <= 0)
            // ) {
            //     this.$toast.error(
            //         "You should fill in the explanation field"
            //     );
            //     return;
            // }






            if (
                !this.is_amount_diff &&
                this.questionnnare.is_provide_service === true &&
                this.questionnnare.is_issue_invoice === true &&
                (this.questionnnare.is_receive_payment === false ||
                    this.questionnnare.is_receive_payment === true)
            ) {
                if (
                    (!this.sale_line_item.amount ||
                        Number(this.sale_line_item.amount) <= 0) &&
                    (this.sale_line_item.status.id === 1 ||
                        this.sale_line_item.status.id === 12 ||
                        this.sale_line_item.status.id === 14)
                ) {
                    console.error(
                        "Amount validation failed. Amount is ",
                        this.sale_line_item.amount
                    );
                    this.$toast.error("You should fill in the amounts");
                }  else if (
                    this.sale_line_item.deal_line_item.deal
                        .commission_type_id !== 1 &&
                    Number(this.sale_line_item.hard_cost) >
                        Number(this.sale_line_item.amount) *
                            (Number(
                                this.sale_line_item.deal_line_item.deal.cap
                            ) /
                                100) &&
                    !this.sale_line_item.explanation
                ) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                } else {
                    if (this.collected_less_amount.some(reason => reason.id === this.selected_reason) || this.amount_less_collected.some(reason => reason.id === this.selected_reason)) {
                        this.onSendCancelReasonFromQue(Number(this.selected_reason));
                    } else {
                        if (this.questionnnare.is_receive_payment) {
                            this.onSendCancelReasonFromQue(15);
                        } else {
                            this.onSendCancelReasonFromQue(16);
                        }
                    }

                    this.resetFormState();
                    await this.onNextSale("OnSave");
                    scrollToTop();
                }
                return;
            }

            if (this.is_amount_diff && this.selected_reason) {
                await this.onSubmitCancelReason();
                return;
            }

            //  Questionnaire end

            // Validation if type_record is not selected
            if (!this.type_record) {
                this.$toast.error("You should select an answer");
                return;
            }

            // Handling amount difference scenario
            if (
                !this.is_collected_section &&
                !this.is_amount_diff &&
                this.sale_line_item.amount &&
                this.sale_line_item.collected &&
                Number(this.sale_line_item.amount) !==
                    Number(this.sale_line_item.deal_line_item.amount) &&
                this.sale_line_item.status.id === 1 &&
                this.sale_line_item.deal_line_item.type_id === 1 &&
                !this.sale_line_item.deal_line_item.fluctuating_fee &&
                this.type_record === 1
            ) {
                if (
                    this.sale_line_item.deal_line_item.deal
                        .commission_type_id !== 1 &&
                    Number(this.sale_line_item.hard_cost) >
                        Number(this.sale_line_item.amount) *
                            (Number(
                                this.sale_line_item.deal_line_item.deal.cap
                            ) /
                                100) &&
                    !this.sale_line_item.explanation
                ) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                }
                this.is_amount_diff = true;
                return;
            }

            // Validate amount difference reason selection
            if (this.is_amount_diff && !this.selected_reason) {
                this.$toast.error("You should select an answer");
                return;
            }

            // Handling collected section and not value for collected scenario
            if (
                this.is_collected_section &&
                this.type_record === 11 &&
                this.sale_line_item.status.id === 6 &&
                !this.is_not_value_for_collected
            ) {
                resetFormState();
                this.is_collected_section = true;
                this.is_not_value_for_collected = true;

                return;
            }

            // Validate explanation for not value for collected
            if (
                this.is_collected_section &&
                this.is_not_value_for_collected &&
                !this.sale_line_item.explanation
            ) {
                this.$toast.error("You should fill in the explanation field");
                return;
            }

            if (
                this.is_collected_section &&
                this.is_not_value_for_collected &&
                this.sale_line_item.explanation
            ) {
                this.selected_reason = 11;
                await this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            // Submit cancel reason if type_record is 11 and status is 5
            if (
                this.is_collected_section &&
                this.type_record === 11 &&
                this.sale_line_item.status.id === 5
            ) {
                this.selected_reason = 11;
                await this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            if (this.is_billing_delayed) {
                if (!this.selected_reason) {
                    this.$toast.error("You should select an answer");
                    return;
                }

                if (!this.selected_reason || !this.sale_line_item.explanation) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                }
            }

            if (
                this.is_collected_section &&
                this.type_record === 10 &&
                !this.sale_line_item.collected
            ) {
                this.$toast.error("You should fill in the collection field");
                return;
            }

            // Submit cancel reason if type_record is 10 and status is 5 or 6
            if (
                this.is_collected_section &&
                this.type_record === 10 &&
                (this.sale_line_item.status.id === 5 ||
                    this.sale_line_item.status.id === 6)
            ) {
                this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            // Submit cancel reason if amount difference reason is selected
            if (this.is_amount_diff && this.selected_reason) {
                this.onSubmitCancelReason();
                scrollToTop();

                return;
            }

            // Submit cancel reason if no service provided (type_record is 3) or billing delayed (type_record is 2)
            if (
                (this.questionnnare.is_provide_service === true &&
                    this.questionnnare.is_issue_invoice === false) ||
                (this.is_no_service_prodided &&
                    this.questionnnare.is_provide_service === false) ||
                (this.is_no_service_prodided && this.type_record === 3) ||
                (this.is_billing_delayed && this.type_record === 2)
            ) {
                let __reason = Number(this.selected_reason);

                if (!this.selected_reason || !this.sale_line_item.explanation) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                }

                if (
                    this.is_no_service_prodided &&
                    this.questionnnare.is_provide_service === false &&
                    this.type_record === 3 &&
                    !this.reasons_list.some((reas) => reas.id === __reason)
                ) {
                    this.$toast.error("You should select an answer");
                    return;
                }

                if (
                    this.is_billing_delayed &&
                    this.type_record === 2 &&
                    !this.billing_reasons.some((reas) => reas.id === __reason)
                ) {
                    this.$toast.error("You should select an answer");
                    return;
                }

                await this.onSubmitCancelReason();
                scrollToTop();
                return;
            }

            // Handle type_record 3 scenario
            if (this.type_record === 3) {
                scrollToTop();
                resetFormState();
                this.is_no_service_prodided = true;

                return;
            }

            // Handle type_record 2 scenario
            // if (this.type_record === 2) {
            //     scrollToTop();
            //     resetFormState();
            //     this.is_billing_delayed = true;

            //     return;
            // }

            // Handle type_record 1 scenario
            if (this.type_record === 1) {
                if (
                    (!this.sale_line_item.amount ||
                        Number(this.sale_line_item.amount) <= 0) &&
                    (this.sale_line_item.status.id === 1 ||
                        this.sale_line_item.status.id === 12 ||
                        this.sale_line_item.status.id === 14)
                ) {
                    console.error(
                        "Amount validation failed. Amount is ",
                        this.sale_line_item.amount
                    );
                    this.$toast.error("You should fill in the amounts");
                } else if (
                    this.sale_line_item.deal_line_item.deal
                        .commission_type_id !== 1 &&
                    Number(this.sale_line_item.hard_cost) >
                        Number(this.sale_line_item.amount) *
                            (Number(
                                this.sale_line_item.deal_line_item.deal.cap
                            ) /
                                100) &&
                    !this.sale_line_item.explanation
                ) {
                    this.$toast.error(
                        "You should fill in the explanation field"
                    );
                    return;
                } else {
                    this.onNextSale("OnSave 2603");
                    scrollToTop();
                    resetFormState();
                }
                return;
            }
        },

        updateInputAmount: _.debounce(function (value, _id, key) {
            this.updateInputFunction(value, _id, key);
        }, 750),
        updateInputCollected: _.debounce(function (value, _id, key) {
            this.collectedAmountModified = true;
            this.updateInputFunction(value, _id, key);
        }, 750),

        updateInputHardCost: _.debounce(function (value, _id, key) {
            this.updateInputFunction(value, _id, key);
        }, 750),

        updateInvoiceNumber: _.debounce(function (
            value,
            _id,
            key,
            sale_line_item_id = null
        ) {
            this.updateInputFunction(value, _id, key, sale_line_item_id);
        },
        750),

        updateExplanation: _.debounce(function (
            value,
            _id,
            key,
            sale_line_item_id = null
        ) {
            this.updateInputFunction(value, _id, key, sale_line_item_id);
        },
        750),

        updateProjectInvoiceNumber: _.debounce(function (
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            this.updateProjectInputFunction(
                value,
                id,
                key,
                is_new_retainer,
                period
            );
        },
        750),

        updateProjectInputAmount: _.debounce(function (
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            this.updateProjectInputFunction(
                value,
                id,
                key,
                is_new_retainer,
                period
            );
        },
        750),

        updateProjectInputCollected: _.debounce(function (
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            this.collectedAmountModified = true;
            this.updateProjectInputFunction(
                value,
                id,
                key,
                is_new_retainer,
                period
            );
        },
        750),

        updateProjectInputHardCost: _.debounce(function (
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            this.updateProjectInputFunction(
                value,
                id,
                key,
                is_new_retainer,
                period
            );
        },
        750),

        updateProjectExplanation: _.debounce(function (
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            this.updateProjectInputFunction(
                value,
                id,
                key,
                is_new_retainer,
                period
            );
        },
        750),

        updateInputFunction(value, _id, key, sale_line_item_id = null) {
            if (this.sale_line_item && this.initPage) {
                this.isLoading = true;
                this.updateDataByField(key, value, _id, sale_line_item_id);
            }
        },

        updateProjectInputFunction(
            value,
            id,
            key,
            is_new_retainer = false,
            period = null
        ) {
            if (this.initPage) {

                if (key == "cancel_reason_id") {
                    let keyName = value == 12 || value == 13 ? "amount_change_reason" : "cancel_reason_id";
                    key = keyName
                } else if (key == "amount_change_reason") {
                    let keyName = value == 12 || value == 13 ? "amount_change_reason" : "cancel_reason_id";
                    key = keyName
                }
                axios
                    .post("api/wizard/updateDraft", {
                        action: "createProjectSale",
                        data: {
                            key,
                            value,
                            id,
                            is_new_retainer,
                            period,
                        },
                    })
                    .then(() => {
                        this.isLoading = false;
                        this.sale_line_item[key] = value;

                        if (
                            [
                                "invoice_number",
                                "amount",
                                "collected",
                                "hard_cost",
                            ].some((i) => i === key)
                        )
                            this.getData(true);
                    })
                    .catch((err) =>
                        console.error("Err updateProjectInputFunction", err)
                    );
            }
        },

        updateDataByField(
            key,
            value,
            id = 1,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false
        ) {
            axios
                .post("api/wizard/updateDraft", {
                    action: is_new_project
                        ? ""
                        : sale_line_item_id
                        ? "updateSale"
                        : "updateSaleLineItem",
                    data: {
                        key,
                        value,
                        id,
                    },
                })
                .then((res) => {
                    this.isLoading = false;

                    this.sale_line_item[key] = value;

                    if (
                        [
                            "invoice_number",
                            "amount",
                            "collected",
                            "hard_cost",
                        ].some((i) => i === key)
                    )
                        this.getData(true);
                })
                .catch((err) => console.error("Err updateDataByField", err));
        },

        onNextSale(from) {
            console.log("CALL onNextSale", from);
            const allSalesPages = this.$store.getters.getAllSalesPages;
            const currentDeal = allSalesPages[this.currentDealIndex];

            this.type_record = null;

            //if (Number(this.sale_line_item.cancel_reason_id) !== 3) this.resetDealCanceledData();

            if (allSalesPages.length && currentDeal.sales.length > 0) {
                if (currentDeal.sales.length - 1 !== this.currentSaleIndex) {
                    if (
                        this.getIndexSLIDealCanceled ===
                            this.currentSaleIndex &&
                        this.isHasDealCanceled
                    ) {
                        this.onSkipAllRequiredSLI();
                        return;
                    }
                    this.handleNextSaleItem(
                        currentDeal.sales[this.currentSaleIndex + 1]
                    );
                } else {
                    this.handleLastSaleItem();
                }
            }
            this.checkDealCanceledSLI(allSalesPages);
        },

        handleNextSaleItem(nextSaleItem) {
            this.type_record = null;

            if (
                Number(nextSaleItem.status.id) === 1 &&
                this.isHasDealCanceled
            ) {
                const allSalesPages = this.$store.getters.getAllSalesPages;
                const currentDeal = allSalesPages[this.currentDealIndex];

                let index_next_sli = currentDeal.sales.findIndex(
                    (sli) => sli.id === nextSaleItem.id
                );

                if (
                    nextSaleItem.is_new_project ||
                    nextSaleItem.is_new_retainer
                ) {
                    index_next_sli = currentDeal.sales.findIndex(
                        (sli) =>
                            sli.deal_line_item.id ===
                                nextSaleItem.deal_line_item.id &&
                            sli.period === nextSaleItem.period
                    );
                }

                if (index_next_sli > this.getIndexSLIDealCanceled) {
                    console.log(index_next_sli, this.getIndexSLIDealCanceled);
                    this.$store.commit("incrementSaleIndex");
                    this.onNextSale("handleNextSaleItem");
                    return;
                }
            }

            this.sale_line_item = nextSaleItem;

            this.selected_reason = nextSaleItem.cancel_reason_id
                ? Number(nextSaleItem.cancel_reason_id)
                : null;

            if (
                this.sale_line_item.status.id === 5 ||
                this.sale_line_item.status.id === 6
            ) {
                this.is_collected_section = true;
                this.type_record = null;
                if (this.sale_line_item.hasOwnProperty("cancel_reason_id")) {
                    this.selected_reason = this.sale_line_item.cancel_reason_id
                        ? Number(this.sale_line_item.cancel_reason_id)
                        : null;
                }

                if (Number(this.sale_line_item.cancel_reason_id) === 10) {
                    this.type_record = 10;
                }

                if (Number(this.sale_line_item.cancel_reason_id) === 11) {
                    this.type_record = 11;
                }
            } else {
                this.type_record = null;
                if (nextSaleItem.hasOwnProperty("cancel_reason_id")) {
                    this.selected_reason = nextSaleItem.cancel_reason_id
                        ? Number(nextSaleItem.cancel_reason_id)
                        : null;
                }

                if (
                    (Number(nextSaleItem.cancel_reason_id) > 5 &&
                        Number(nextSaleItem.cancel_reason_id) <= 9) ||
                    Number(nextSaleItem.cancel_reason_id) == 18
                ) {
                    this.questionnnare.is_provide_service = true;
                    this.questionnnare.is_issue_invoice = false;
                    this.type_record = 2;
                } else if (
                    Number(nextSaleItem.cancel_reason_id) == 12 ||
                    nextSaleItem.cancel_reason_id == 13
                ) {
                    this.type_record = 1;
                } else if (
                    (Number(nextSaleItem.cancel_reason_id) >= 1 &&
                        Number(nextSaleItem.cancel_reason_id) <= 5) ||
                    Number(nextSaleItem.cancel_reason_id) == 14 ||
                    Number(nextSaleItem.cancel_reason_id) == 17
                ) {
                    this.type_record = 3;
                    this.questionnnare.is_provide_service = false;
                } else if (!Number(nextSaleItem.cancel_reason_id)) {
                    if (nextSaleItem.amount) {
                        this.type_record = 1;
                    } else {
                        this.type_record = null;
                    }
                } else if (Number(nextSaleItem.cancel_reason_id) === 15) {
                    this.questionnnare.is_provide_service = true;
                    this.questionnnare.is_issue_invoice = true;
                    this.questionnnare.is_receive_payment = true;
                } else if (Number(nextSaleItem.cancel_reason_id) === 16) {
                    this.questionnnare.is_provide_service = true;
                    this.questionnnare.is_issue_invoice = true;
                    this.questionnnare.is_receive_payment = false;
                } else {
                    this.type_record = null;
                }
            }

            this.$store.commit("incrementSaleIndex");
        },

        handleLastSaleItem() {
            if (this.editDealId) {
                this.onChangeSection(SECTIONS.FINAL_DASHBOARD);
            } else {
                const allSalesPages = this.$store.getters.getAllSalesPages;
                const currentDeal = allSalesPages[this.currentDealIndex];
                const salesPages = this.$store.getters.getSalesPages(
                    this.$store.getters.getSalesPagesIndex + 1
                );
                if (currentDeal.has_dli) {
                    if (this.isHasDealCanceled) {
                        if (salesPages) {
                            this.sale_line_item =
                                allSalesPages[
                                    this.currentDealIndex + 1
                                ].sales[0];

                            this.$store.commit(
                                "setSalesPagesIndex",
                                this.$store.getters.getSalesPagesIndex + 1
                            );
                            this.$store.commit("incrementDealIndex");
                            this.$store.commit("setSaleIndex", 0);
                            this.resetDealCanceledData(
                                "handleLastSaleItem isHasDealCanceled if"
                            );
                            this.$forceUpdate();
                            return;
                        } else {
                            this.resetDealCanceledData(
                                "handleLastSaleItem isHasDealCanceled else"
                            );
                            this.onChangeSection(
                                SECTIONS.INVOICES,
                                SECTIONS.EDIT_SALE_LINE_ITEM
                            );
                            return;
                        }
                    }
                    this.onChangeSection(SECTIONS.DO_YOU_HAVE_UPSELL);
                } else {
                    if (salesPages) {
                        this.sale_line_item =
                            allSalesPages[this.currentDealIndex + 1].sales[0];
                        this.$store.commit(
                            "setSalesPagesIndex",
                            this.$store.getters.getSalesPagesIndex + 1
                        );
                        this.$store.commit("incrementDealIndex");
                        this.$store.commit("setSaleIndex", 0);
                        this.resetDealCanceledData("else else");
                        this.selected_reason = this.sale_line_item
                            .cancel_reason_id
                            ? Number(this.sale_line_item.cancel_reason_id)
                            : null;

                        if (
                            this.sale_line_item.status.id === 5 ||
                            this.sale_line_item.status.id === 6
                        ) {
                            this.is_collected_section = true;
                            this.type_record = null;
                            if (
                                this.sale_line_item.hasOwnProperty(
                                    "cancel_reason_id"
                                )
                            ) {
                                this.selected_reason = this.sale_line_item
                                    .cancel_reason_id
                                    ? Number(
                                          this.sale_line_item.cancel_reason_id
                                      )
                                    : null;
                            }

                            if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                10
                            ) {
                                this.type_record = 10;
                            }

                            if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                11
                            ) {
                                this.type_record = 11;
                            }
                        } else {
                            this.type_record = null;
                            if (
                                this.sale_line_item.hasOwnProperty(
                                    "cancel_reason_id"
                                )
                            ) {
                                this.selected_reason = this.sale_line_item
                                    .cancel_reason_id
                                    ? Number(
                                          this.sale_line_item.cancel_reason_id
                                      )
                                    : null;
                            }

                            if (
                                (Number(this.sale_line_item.cancel_reason_id) >
                                    5 &&
                                    Number(
                                        this.sale_line_item.cancel_reason_id
                                    ) <= 9) ||
                                Number(this.sale_line_item.cancel_reason_id) ==
                                    18
                            ) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = false;
                                this.type_record = 2;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ==
                                    12 ||
                                this.sale_line_item.cancel_reason_id == 13
                            ) {
                                this.type_record = 1;
                            } else if (
                                (Number(this.sale_line_item.cancel_reason_id) >=
                                    1 &&
                                    Number(
                                        this.sale_line_item.cancel_reason_id
                                    ) <= 5) ||
                                Number(this.sale_line_item.cancel_reason_id) ==
                                    14 ||
                                Number(this.sale_line_item.cancel_reason_id) ==
                                    17
                            ) {
                                this.type_record = 3;
                                this.questionnnare.is_provide_service = false;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                15
                            ) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                16
                            ) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = false;
                            } else if ( [19, 20, 21, 24, 22, 23, 25].includes(Number(this.sale_line_item.cancel_reason_id))) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                            } else if (
                                !Number(this.sale_line_item.cancel_reason_id)
                            ) {
                                if (
                                    this.sale_line_item.amount &&
                                    this.sale_line_item.collected
                                ) {
                                    this.type_record = 1;
                                } else {
                                    this.type_record = null;
                                }
                            } else {
                                this.type_record = null;
                            }
                        }

                        this.$forceUpdate();
                    } else {
                        this.onChangeSection(
                            SECTIONS.DO_YOU_HAVE_UPSELL,
                            SECTIONS.EDIT_SALE_LINE_ITEM
                        );
                    }
                }
            }
        },

        async onSelectSaleLineItemType(e) {

            if (e.target.value == 11) {
                this.collectedAmountModified = false;
                this.selected_reason = 11;
                return;
            } else if (e.target.value == 10) {
                this.collectedAmountModified = true;
            } else {
                this.collectedAmountModified = false;
            }

            if (e.target.value == 3 || e.target.value == 2) {
                return;
            }

            // Update cancel_reason_id based on the sale type
            try {
                let postData;
                let keyName = this.selected_reason_amount_reasons == 12 || this.selected_reason_amount_reasons == 13  ? "amount_change_reason" : "cancel_reason_id";


                if (
                    !this.sale_line_item.is_new_project &&
                    !this.sale_line_item.is_new_retainer
                ) {
                    postData = {
                        action: "updateSaleLineItem",
                        data: {
                            key: keyName,
                            value: null,
                            id: this.sale_line_item.id,
                        },
                    };
                } else {
                    postData = {
                        action: "createProjectSale",
                        data: {
                            key: keyName,
                            value: null,
                            id: this.sale_line_item.deal_line_item.id,
                            is_new_retainer:
                                this.sale_line_item.is_new_retainer || false,
                            period: this.sale_line_item.period,
                        },
                    };
                }

                await axios.post("api/wizard/updateDraft", postData);
                this.getData(true);
            } catch (error) {
                console.error("Error updating draft:", error);
                // Handle error as needed
            }

            this.selected_reason = e.target.value;
        },

        onChangeReasonType(e) {

            const value = Number(e.target.value);
            // console.log("selected_reason:", value)
            // console.log(typeof(value))
            if (value && (value !== 12 && value !== 13)) this.selected_reason = value;
            if (value === 12 || value === 13) this.selected_reason_amount_reasons = value;
            // this.selected_reason = value;

            // console.log("selected_reason!!!:", this.selected_reason)
            // console.log("selected_reason_amount_reasons:", this.selected_reason_amount_reasons)

        },

        kickOffDateFormat(date = null) {
            if (date) {
                const formattedDate = moment(date).format("MM/DD/YYYY");

                return formattedDate;
            }

            return "";
        },

        checkDealCanceledSLI(data = null) {
            if (data) {
                const currentIndexDeal = this.currentDealIndex;

                if (data[currentIndexDeal].sales.length) {
                    const canceledDealSLI = data[currentIndexDeal].sales.find(
                        (sale) =>
                            Number(sale.cancel_reason_id) === 3 ||
                            Number(sale.cancel_reason_id) === 2
                    );
                    const indexCanceledDealSLI = data[
                        currentIndexDeal
                    ].sales.findIndex(
                        (sale) =>
                            Number(sale.cancel_reason_id) === 3 ||
                            Number(sale.cancel_reason_id) === 2
                    );

                    if (canceledDealSLI) {
                        this.$store.commit("setIsDealCanceled", true);
                        this.$store.commit(
                            "setIndexSLIWithDealCanceled",
                            indexCanceledDealSLI
                        );
                        if (
                            canceledDealSLI.is_new_project ||
                            canceledDealSLI.is_new_retainer
                        ) {
                            this.$store.commit(
                                "setIdSLIWithDealCanceled",
                                canceledDealSLI.deal_line_item.id
                            );
                        } else {
                            this.$store.commit(
                                "setIdSLIWithDealCanceled",
                                canceledDealSLI.id
                            );
                        }

                        return true;
                    }
                }
            }

            return false;
        },

        isCurrentDealCanceled() {
            if (
                Number(this.sale_line_item.cancel_reason_id) === 3 ||
                Number(this.sale_line_item.cancel_reason_id) === 2
            ) {
                return true;
            }

            return false;
        },

        onSkipAllRequiredSLI() {
            const allSalesPages = this.$store.getters.getAllSalesPages;

            const currentDeal = allSalesPages[this.currentDealIndex];

            const __splitArray = currentDeal.sales.slice(this.currentSaleIndex);

            if (__splitArray.length) {
                const __sli = __splitArray.find((sale) => sale.status.id !== 1);

                if (!__sli) {
                    const salesPages = this.$store.getters.getSalesPages(
                        this.$store.getters.getSalesPagesIndex + 1
                    );
                    console.log("salespages", salesPages);
                    if (salesPages) {
                        this.$store.commit(
                            "setSalesPagesIndex",
                            this.$store.getters.getSalesPagesIndex + 1
                        );
                        this.$store.commit("incrementDealIndex");
                        this.$store.commit("setSaleIndex", 0);
                        this.resetDealCanceledData("onSkipAllRequiredSLI");
                        this.sale_line_item = salesPages.sales[0];

                        if (
                            this.sale_line_item.status.id === 5 ||
                            this.sale_line_item.status.id === 6
                        ) {
                            this.is_collected_section = true;
                            this.type_record = null;
                            if (
                                this.sale_line_item.hasOwnProperty(
                                    "cancel_reason_id"
                                )
                            ) {
                                this.selected_reason = this.sale_line_item
                                    .cancel_reason_id
                                    ? Number(
                                          this.sale_line_item.cancel_reason_id
                                      )
                                    : null;
                            }

                            if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                10
                            ) {
                                this.type_record = 10;
                            }

                            if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                11
                            ) {
                                this.type_record = 11;
                            }
                        } else {
                            this.type_record = null;
                            if (
                                this.sale_line_item.hasOwnProperty(
                                    "cancel_reason_id"
                                )
                            ) {
                                this.selected_reason = this.sale_line_item
                                    .cancel_reason_id
                                    ? Number(
                                          this.sale_line_item.cancel_reason_id
                                      )
                                    : null;
                            }

                            if (
                                Number(this.sale_line_item.cancel_reason_id) >
                                    5 &&
                                Number(this.sale_line_item.cancel_reason_id) <=
                                    9
                            ) {
                                this.type_record = 2;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ==
                                    12 ||
                                this.sale_line_item.cancel_reason_id == 13
                            ) {
                                this.type_record = 1;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) >=
                                    1 &&
                                Number(this.sale_line_item.cancel_reason_id) <=
                                    5
                            ) {
                                this.type_record = 3;
                                this.questionnnare.is_provide_service = false;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                15
                            ) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                            } else if (
                                Number(this.sale_line_item.cancel_reason_id) ===
                                16
                            ) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = false;
                            } else if ( [19, 20, 21, 24, 22, 23, 25].includes(Number(this.sale_line_item.cancel_reason_id))) {
                                this.questionnnare.is_provide_service = true;
                                this.questionnnare.is_issue_invoice = true;
                                this.questionnnare.is_receive_payment = true;
                            } else if (
                                !Number(this.sale_line_item.cancel_reason_id)
                            ) {
                                if (
                                    this.sale_line_item.amount &&
                                    this.sale_line_item.collected
                                ) {
                                    this.type_record = 1;
                                } else {
                                    this.type_record = null;
                                }
                            } else {
                                this.type_record = null;
                            }
                        }
                    } else {
                        this.onChangeSection(
                            SECTIONS.INVOICES,
                            SECTIONS.EDIT_SALE_LINE_ITEM
                        );
                    }
                    return;
                }

                const __index = currentDeal.sales.findIndex(
                    (sli) => sli.id === __sli.id
                );

                this.sale_line_item = __sli;

                this.type_record = null;
                this.selected_reason = __sli.cancel_reason_id
                    ? Number(__sli.cancel_reason_id)
                    : null;

                if (
                    this.sale_line_item.status.id === 5 ||
                    this.sale_line_item.status.id === 6
                ) {
                    this.is_collected_section = true;
                    this.type_record = null;
                    if (
                        this.sale_line_item.hasOwnProperty("cancel_reason_id")
                    ) {
                        this.selected_reason = this.sale_line_item
                            .cancel_reason_id
                            ? Number(this.sale_line_item.cancel_reason_id)
                            : null;
                    }

                    if (Number(this.sale_line_item.cancel_reason_id) === 10) {
                        this.type_record = 10;
                    }

                    if (Number(this.sale_line_item.cancel_reason_id) === 11) {
                        this.type_record = 11;
                    }
                } else {
                    this.type_record = null;
                    if (__sli.hasOwnProperty("cancel_reason_id")) {
                        this.selected_reason = __sli.cancel_reason_id
                            ? Number(__sli.cancel_reason_id)
                            : null;
                    }

                    if (
                        Number(__sli.cancel_reason_id) > 5 &&
                        Number(__sli.cancel_reason_id) <= 9
                    ) {
                        this.type_record = 2;
                    } else if (
                        Number(__sli.cancel_reason_id) == 12 ||
                        __sli.cancel_reason_id == 13
                    ) {
                        this.type_record = 1;
                    } else if (
                        Number(__sli.cancel_reason_id) >= 1 &&
                        Number(__sli.cancel_reason_id) <= 5
                    ) {
                        this.type_record = 3;
                        this.questionnnare.is_provide_service = false;
                    } else if (Number(sale.cancel_reason_id) === 15) {
                        this.questionnnare.is_provide_service = true;
                        this.questionnnare.is_issue_invoice = true;
                        this.questionnnare.is_receive_payment = true;
                    } else if (Number(sale.cancel_reason_id) === 16) {
                        this.questionnnare.is_provide_service = true;
                        this.questionnnare.is_issue_invoice = true;
                        this.questionnnare.is_receive_payment = false;
                    } else if (!Number(__sli.cancel_reason_id)) {
                        if (__sli.amount && __sli.collected) {
                            this.type_record = 1;
                        } else {
                            this.type_record = null;
                        }
                    } else {
                        this.type_record = null;
                    }
                }

                this.$store.commit("setSaleIndex", __index);
            } else {
                const salesPages = this.$store.getters.getSalesPages(
                    this.$store.getters.getSalesPagesIndex + 1
                );
                if (salesPages) {
                    this.$store.commit(
                        "setSalesPagesIndex",
                        this.$store.getters.getSalesPagesIndex + 1
                    );
                    this.$store.commit("incrementDealIndex");
                    this.$store.commit("setSaleIndex", 0);
                    this.resetDealCanceledData("onSkipAllRequiredSLI");
                }
            }
        },

        resetDealCanceledData(from = "") {
            this.$store.commit("setIsDealCanceled", false);
            this.$store.commit("setIdSLIWithDealCanceled", null);
            this.$store.commit("setIndexSLIWithDealCanceled", null);
        },

        onChangeProvideService(flag = false) {
            this.questionnnare.is_provide_service = flag;
            this.questionnnare.is_issue_invoice = null;
            this.questionnnare.is_receive_payment = null;
        },

        onChangeIssueService(flag = false) {
            this.questionnnare.is_issue_invoice = flag;
            this.questionnnare.is_receive_payment = null;
        },

        onChangeReceivePayment(flag = false) {
            if (flag === true && [19, 20, 21, 24, 22, 23, 25].includes(this.selected_reason)) {
                this.questionnnare.is_receive_payment = true;
            }

            this.questionnnare.is_receive_payment = flag;
        },

        async onSendCancelReasonFromQue(value) {
            // Update cancel_reason_id based on the sale type
            try {
                const update_data = {
                    key: "cancel_reason_id",
                    value: value,
                };

                this.$store.commit("updateSaleCancelReasonId", {
                    deal_index: this.currentDealIndex,
                    sale_index: this.currentSaleIndex,
                    data: update_data,
                });

                let postData;
                if (
                    !this.sale_line_item.is_new_project &&
                    !this.sale_line_item.is_new_retainer
                ) {
                    postData = {
                        action: "updateSaleLineItem",
                        data: {
                            key: "cancel_reason_id",
                            value: value,
                            id: this.sale_line_item.id,
                        },
                    };
                } else {
                    postData = {
                        action: "createProjectSale",
                        data: {
                            key: "cancel_reason_id",
                            value: value,
                            id: this.sale_line_item.deal_line_item.id,
                            is_new_retainer:
                                this.sale_line_item.is_new_retainer || false,
                            period: this.sale_line_item.period,
                        },
                    };
                }
                console.log(postData)

                await axios.post("api/wizard/updateDraft", postData);
                this.getData(true);
            } catch (error) {
                console.error("Error updating draft:", error);
                // Handle error as needed
            }
        },
        async sendLogToServer(message, level = "info") {
            try {
                await axios.post("/api/logs", {
                    message: JSON.stringify(message),
                    level,
                });
            } catch (error) {
                console.error("Do not send log:", error);
            }
        },
    },
};
</script>
